/* eslint-disable */
/* eslint-disable prefer-const */
/* eslint-disable no-var */
/* eslint-disable no-debugger */
/* eslint-disable react/no-children-prop */
/* eslint-disable sonarjs/no-redundant-jump */
/* eslint-disable prettier/prettier */
/* eslint-disable sonarjs/no-duplicate-string */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable sonarjs/cognitive-complexity */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-console */
import React from 'react';
import { useState, useEffect, useContext, useRef } from 'react';
import { useLocalSourcing } from './useLocalSourcing';
import { consolidateItemsByRmsNumber } from '../../../utils/consolidateItems';
import { agreementGlobalStyles } from '../../../JSstyles/agreementGlobalStyles';
import { agrGeneralInfoStyles } from '../../../JSstyles/agrGeneralInfoStyles';
import { paymentCost } from '../../../JSstyles/paymentCost';
import PaymentScheduleCard from '../../Shared/PaymentScheduleCard';
import moment from 'moment';

import {
  Grid,
  Typography,
  RACSelect,
  RACButton,
  Card,
  CardContent,
  CircularProgress,
  RACModalCard,
  RACCOLOR,
  RACTextbox,
  RACInfoIcon
} from '@rentacenter/racstrap';
import { ContainerContext } from '../../../app/App';
import { CustomPropInterface } from '../../../index';
import { SearchResultItem } from '../../../types/types';
import { ReactComponent as Alerticon } from '../../../assets/images/no-records-found.svg';
import { ReactComponent as Infoicon } from '../../../assets/images/info-tooltip.svg';
import { ReactComponent as Infosus } from '../../../assets/images/infosus.svg';

import CurrencyInput from 'react-currency-input-field';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import {
  getCOpriceQuote,
  GetEmployeeID,
  getAgreementInfo,
  GetRole,
  coCreateAgreement,
  GenerateAgreementDoc,
  tireCreateCart,
  tireCOCreateAgreement,
  getAgreementOptions
} from '../../../api/user';
import { SetPendingCOAgreementValue } from '../../../app/Routes';
import { CustomerOrderAgreementContext } from '../../../context/CustomerOrderAgreementContext';
import { useLocation } from 'react-router-dom';
import { useRouteParams } from '../../../utils/useRouteParams';
import { useHistory } from 'react-router';
import SecondFactor from '../../Rental/TwoFactorPopup/TwoFactorPopup';
import CustomerSignature from '../../Shared/CustomerSignature';
import { AgreementContext } from '../../../context/AgreementContext';
import { FeatureFlagContext } from '../../../context/FeatureFlagContext';
import { ReactComponent as Successicon } from '../../../assets/images/success-icon.svg'
import VoidAgreement from '../../Rental/AddCoCustomer/voidagreement';

import { is } from 'date-fns/locale';
import { useTranslation } from 'react-i18next';
import { toFiniteNumber } from '../../../utils/deEnforcementUtils';
import { useDEEnforcementGate, DEOverrideAuthGate } from '../../Shared/DEEnforcementGate';
interface Params {
  customerId: string;
  agreementId: string;
}
export default function CustomerOrderAgrDetails({
  CoCustomerDetails: { coCustomerId },
  setItemSearchCompleted,
}) {

  const {i18n, t} = useTranslation('customer');
  const {language, customerPromotions, customerTierDetails, getCustomerResponse, customerTierCodes, deOverrideApproverDetails, setDeOverrideApproverDetails }= useContext(AgreementContext);
  const deOverrideApproverDetailsRef = useRef<typeof deOverrideApproverDetails>(null);

  const containerData = useContext(ContainerContext) as CustomPropInterface;
  const history = useHistory();
  const location = useLocation();
  const search = location.search;
  const salesLeadId = new URLSearchParams(search).get('salesLeadId');
  const isTireBuyerFlow = new URLSearchParams(search).get('tbflow');
  const classes = agreementGlobalStyles()
  const agrGeneralInfoClassName = agrGeneralInfoStyles();
  const paymentCostClassName = paymentCost();
  const [errbackupVal, seterrbackupVal] = useState('');
  const { customerId, agreementId } = useRouteParams();
  const { featureFlagDetails, deEnforcementConfig } = useContext(FeatureFlagContext);
  // Enable Referral in Customer Orders only when both global and CO-specific flags are enabled.
  const isCOReferralEnabled =
    featureFlagDetails?.EnableRewardPromotion === '1' &&
    featureFlagDetails?.EnableCOReferralPromotion === '1';
  const [promoCode, setPromoCode] = useState('');
  const [promoCodeOptions, setPromoCodeOptions] = useState([]);
  const [promoTextInput, setPromoTextInput] = useState('');
  const [promoTextError, setPromoTextError] = useState('');
  const [textBoxPromotions, setTextBoxPromotions] = useState<any[]>([]);
  const defaultDropdownValue = {
    value: '',
    label: t('Select'),
  };
  const initialPaymentAmoutObj = {
    Club: '',
    LDW: '',
    Tax: '',
    Rate: '',
    InitialPayment: '',
  };
  const totalPaymentAmountObj = {
    InitialPayment: '',
    InitialPaymentTerm: '1',
    RegularPayments: '',
    RegularPaymentsTerm: '',
    FinalPayment: '',
    FinalPaymentTerm: '1',
    TotalPayment: '',
    TotalPaymentTerm: '',
    AgreementTotal: '',
    Discount: ''
  };
  const paymentScheduleObj = {
    weeklyRate: '',
    weeklyTerm: '',
    biweeklyRate: '',
    biweeklyTerm: '',
    semimonthlyRate: '',
    semimonthlyTerm: '',
    monthlyRate: '',
    monthlyTerm: '',
  };
  const selectedScheduleObj = {
    WeeklySchedule: false,
    BiWeeklySchedule: false,
    MonthlySchedule: false,
    SemiMonthlySchedule: false,
  };
  const payScheduleObj = {
    PayschedulePeriod: '',
    PayscheduleDay: '',
  };
  const {
    searchResult,
    setsearchResult,
    setagreementCreateStatus,
    agreementOptions,
    setagreementOptions,
    successDropdownValues,
    setsuccessDropdownValues,
    wholeAgrInfoResponse,
    setwholeAgrInfoResponse,
    setAgreementId,
    AgreementId,
    PromoCode,
    addedItems,
    modelNumberArray,
    customerInformation,
    year, setYear,
    make, setMake,
    model, setModel,
    style, setStyle,
    size, setSize,
    tagRate, tagTerm,
    totalCashPrice, setTotalCashPrice,
    agreementTotal, setagreementTotal,
    agreementRate, setAgreementRate,
    agreementTerm, setAgreementTerm,
    salesleadFitemnetid, setsalesleadFitemnetid,
    salesinstallerName, setsalesinstallerName,
    salesinstalldate, setsalesinstalldate,
    salesTimeSlot, setSalesTimeSlot,
    salesLeadData,
    deEnforcementBaseline, setDeEnforcementBaseline
  } = useContext(CustomerOrderAgreementContext);
  const { setIsAllDone, setRewardErrorMessage, setRewardPromotion, setCustomerReferralCode, rewardErrorMessage, customerReferralCode, rewardPromotion } = useContext(AgreementContext);
  // const PopupCompleteObj = {
  //   VehicleInfoComplete: false,
  //   ConfirmDueDateComplete: false,
  //   AgreementCreated: false,
  //   CustomerSignComplete: false,
  //   PrintPopupComplete: false,
  //   SendAgreementComplete: false,
  //   AutoPayComplete: false,
  //   SMSAutheticationComplete: false,
  //   InitialPaymentComplete: false,
  // };

  const PopupCompleteObj = {
    AgreementCreated: false,
    AgreementSigned: false,
    CustomerSignComplete: false,
    InitialPaymentComplete: false,
    PrelimpaymentPaymentComplete: false,
    AgreementStatus: '',
  };
  const [PopupCompleteStatus, setPopupCompleteStatus] =
    useState(PopupCompleteObj);
  const [processFeeDisable, setprocessFeeDisable] = useState<boolean>(false)
  const [pageLoading, setpageLoading] = useState(true);
  const [scheduleLoading, setscheduleLoading] = useState(true);
  const [editDisableMode, seteditDisableMode] = useState(true);
  const [selectedSchedule, setselectedSchedule] = useState(selectedScheduleObj);
  const [paymentScheduleEnabled, setpaymentScheduleEnabled] = useState(true);
  const [payschedule, setpayschedule] = useState(payScheduleObj);

  const [paymentScheduleValues, setpaymentScheduleValues] =
    useState(paymentScheduleObj);
  // const [AgreementId, setAgreementId] = useState('');
  const [agreementSourceOptions, setagreementSourceOptions] = useState([
    {
      value: '',
      label: t('Select'),
    },
  ]);
  console.log("agreementoptions",agreementSourceOptions);
  const [scheduleOptions, setscheduleOptions] = useState([
    {
      value: '',
      label: t('Select'),
    },
  ]);
  const [rangeOptions, setrangeOptions] = useState([
    {
      value: '',
      label: t('Select'),
    },
  ]);
  const [offerCodeOptions, setofferCodeOptions] = useState([
    {
      value: '',
      label: t('Select'),
    },
  ]);
  const [optServiceOptions, setoptServiceOptions] = useState([
    {
      value: '',
      label: t('Select'),
    },
  ]);
  const [salesPersonOptions, setsalesPersonOptions] = useState([
    {
      value: '',
      label: t('Select'),
    },
  ]);
  const [SecondFactorOpen, setSecondFactorOpen] = useState(false);
  const [ProcessingFeeErrorLbl, setProcessingFeeErrorLbl] = useState(false);
  const [ProcessingFeeLimit, setProcessingFeeLimit] = useState('0.00');
  const [OtherAmt, setOtherAmt] = useState('0.00');
  const [intialAmountCalc, setInitialAmountCalc] = useState('');
  const [ProcessingFeePopupOpen, setProcessingFeePopupOpen] = useState(false);
  const [agreementSourceValue, setagreementSourceValue] = useState('');
  const [scheduleValue, setscheduleValue] = useState('');
  const [rangeValue, setrangeValue] = useState('SEMI1-15');
  const [offerCodeValue, setofferCodeValue] = useState('');
  const [optServiceValue, setoptServiceValue] = useState('');

  // Local Sourcing hook — manages LS state derivation, agreement options fetch, and payload enrichment
  const { isLocalSourcingFlow, applyLocalSourcingPayload } = useLocalSourcing({
    customerId,
    searchResult,
    setsearchResult,
    setagreementOptions,
    offerCodeValue,
  });
  const [salesPersonValue, setsalesPersonValue] = useState('');
  const [termValue, settermValue] = useState('');
  const [rangeactive, setrangeactive] = useState(false);
  const [processingFee, setprocessingFee] = useState('0.00');
  const [wlDeposit, setwlDeposit] = useState('0.00');
  const [sacAmount, setsacAmount] = useState();
  const [initialPaymentAmount, setinitialPaymentAmount] = useState(
    initialPaymentAmoutObj
  );
  const [GenerateDocReq, setGenerateDocReq] = useState({});
  const [totalPaymentAmount, settotalPaymentAmount] = useState(
    totalPaymentAmountObj
  );
  const [paymentPopupOpen, setpaymentPopupOpen] = useState(false);
  const [previousBtnDisabled, setpreviousBtnDisabled] = useState(false);
  const [nextBtnDisabled, setnextBtnDisabled] = useState(true);
  const [priceQuoteReq, setpriceQuoteReq] = useState<any>({});
  const [priceQuoteRes, setpriceQuoteRes]: any = useState({});
  const [createAgreementReq, setcreateAgreementReq] = useState({});
  const [somethingWentWrong, setsomethingWentWrong] = useState(false);
  const [apiFailPopupOpen, setapiFailPopupOpen] = useState(false);
  const [AgrSourceDisable, setAgrSourceDisable] = useState(false);
  const [apiFailFirstMessage, setapiFailFirstMessage] = useState('Oops');
  const [apiFailSecondMessage, setapiFailSecondMessage] = useState(
    t('Unable to create agreement at this moment')
  );
  const [somethingWentWrongOpen, setsomethingWentWrongOpen] = useState(false);
  const [createAgrProcessingPopup, setcreateAgrProcessingPopup] =
    useState(false);
  const [RecalculateReq, setRecalculateReq] = useState({});
  const [dropdownLoading, setdropdownLoading] = useState(true);
  const [dropdownLoaded, setdropdownLoaded] = useState(false);
  const CLUB_STATUS_ACTIVE_PENDING = ['A', 'P'];
  const API_ERROR_MESSAGE = t('Unable to fetch the data');
  const [secondFactorEnabled, setsecondFactorEnabled] = useState(false);
  const [currentRole, setcurrentRole] = useState('');
  const {
    deEnforcementPopup,
    deOverrideAuthOpen,
    setDeOverrideAuthOpen,
    evaluateAndGate: evaluateDEEnforcementAndGate,
    closeDEEnforcementPopup: deEnforcementCloseClick,
    authorizeDEEnforcementOverride: deEnforcementAuthorizeClick,
    recordDEOverrideAudit,
  } = useDEEnforcementGate({
    deEnforcementConfig,
    getCustomerResponse,
    deEnforcementBaseline,
    agreementType: 'SPEC',
    agreementNo: AgreementId ?? agreementId,
    customerId,
    storeNo: window.sessionStorage.getItem('storeNumber'),
    role: currentRole,
    currentScreen: 'Customer Order-Agreement Details',
  });
  const [customerSignatureEnabled, setcustomerSignatureEnabled] =
    useState(false);
  const [documentGenerateCompleted, setdocumentGenerateCompleted] =
    useState(false);
  const [AgrCustomerObj, setAgrCustomerObj]: any = useState([]);
  const [CustomerCoverageData, setCustomerCoverageData] = useState();
  const [ClubStatus, setClubStatus] = useState<any>();
  const [ClubOriginStore, setClubOriginStore] = useState();
  const [IsLdwTiedWithClub, setIsLdwTiedWithClub] = useState();
  const [LDWstatus, setLDWstatus] = useState();
  const [AddingBpclubOpen, setAddingBpclubOpen] = useState(false);
  const [DecliningLdwOpen, setDecliningLdwOpen] = useState(false);
  const ManualSignOptions = [
    {
      value: '',
      label: t('Select'),
    },
    {
      value: '3',
      label: t('Technology issue - Digital Signing'),
    },
    {
      value: '2',
      label: t('Technology issue - Customer'),
    },
    {
      value: '1',
      label: t('Customer requires Paper Signature'),
    },
  ];
  
  const [IsAgreementVoided, setIsAgreementVoided] = useState(false);
  const [VoidEnabled, setVoidEnabled] = useState(false);
  const [agreementStatus, setAgreementStatus] = useState('');

  const updateAgrStatus = async () => {
    try {
      const agrInfoResult = await getAgreementInfo(AgreementId);
      setAgreementStatus(agrInfoResult?.data?.agreementInformation?.agreementStatusRefCode);
    } catch (error) {
      console.error('Error fetching agreement info:', error);
    }
  };

  useEffect(() => {
    if (
      AgreementId !== undefined &&
      AgreementId !== null &&
      AgreementId !== ""
    ) {
      setVoidEnabled(true);
      updateAgrStatus();
    }
  }, [AgreementId]);

  const pull_data = (data) => {
    setIsAgreementVoided(data);
  };

  // Tire buyer states
  const [tbSecondFactor, settbSecondFactor] = useState(false)
  const [iframeUrl, setIframeUrl] = useState('');
  const [tbIframePopup, setTbIframePopup] = useState(false)
  const [installationSuccessfull, setinstallationSuccessfull] = useState(false)
  const [getAgreementInfoRes, setgetAgreementInfoRes] = useState<any>('')
  const [normalFlowCustomerSign, setnormalFlowCustomerSign] = useState(false)
  const [tbCustomerSignCancel, settbCustomerSignCancel] = useState(false)
  const [pageLoader, setpageLoader] = useState(false)
  const [schedulledInstallation, setschedulledInstallation] = useState(true)
  const [rewardEntered, setRewardEntered] = useState<string>('');
  const installerInfoObj = {
    installerName: '',
    emailAddress: '',
    externalPoNumber: '',
    phoneNumber: '',
    installationDate: '',
    installationTime: '',
    installerAddress: {
      addressLine1: '',
      addressLine2: '',
      city: '',
      state: '',
      postalCode: ''
    }
  }
  const [installerInfo, setInstallerInfo] = useState<any>(
    installerInfoObj
  )

  const [vehicleInfo, setvehicleInfo] = useState({
    make: make,
    model: model,
    year: year
  })
  const [rewardAppliedPriceQuoteAmount, setRewardAppliedPriceQuoteAmount] = useState('0.00');
    // state to open SLA
  const [rewardTwoFactorAuth, setRewardTwoFactorAuth] = useState<any>(false);
  const [tierPromotionsValue, setTierPromotionsValue] = useState<any>()
  const [matchingPromotions, setMatchingPromotions] = React.useState<any>([]);

  const trackInvalidTextBoxPromo = (promoNumber: string) => {
    window?.dataLayer?.push({
      event: 'Applied invalid text box promo',
      customerId,
      storeNo: window.sessionStorage.getItem('storeNumber'),
      employeeId: containerData?.GetEmployeeId?.() || '',
      role: currentRole || containerData?.GetRole?.() || '',
      currentScreen: 'Customer Order-Agreement Details',
      previousScreen: 'Customer Order-Item Search',
      promoNumber,
      source: 'RACPAD'
    });
  };

  useEffect(() => {
      const filteredPromotions = customerPromotions?.promotions?.filter((promotion) => {
        return promotion.promotionNumber == offerCodeValue ||
          promotion.promotionCode == offerCodeValue;
      }) || [];
  
      setMatchingPromotions(filteredPromotions);
      console.log(filteredPromotions, 'matchingPromotions');
    }, [customerPromotions, offerCodeValue]);

  useEffect(() => {
    const filtered = customerPromotions?.promotions?.filter(
      (p: any) => p.isTextBoxPromotion === 'Y'
    ) || [];
    setTextBoxPromotions(filtered);
  }, [customerPromotions]);

  const priceQuoteInitialized = useRef(false);
  useEffect(() => {
    if (priceQuoteInitialized.current) return;
    debugger;
    const priceQuoteReqTemp: any = priceQuoteReq;
    const createAgreementReqTemp: any = createAgreementReq;
    console.log('agreementOptions', agreementOptions);
    console.log('searchResult[0]', searchResult);
    if (
      searchResult != undefined &&
      searchResult.length > 0 &&
      agreementOptions != undefined &&
      agreementId == undefined
    ) {
      priceQuoteInitialized.current = true;
      priceQuoteReq.rmsItemNumbers = searchResult.map((obj: SearchResultItem) => {
        return obj.rmsItemNumber
      })

      // Local Sourcing: On initial load, send per-item pricing in rmsPricingInfo
      // with null at parent level so BE can accumulate per-item totals (qty * rate).
      // On subsequent calls (after response populates agreementRate), use the populated values.
      if (isLocalSourcingFlow && !agreementRate) {
        priceQuoteReqTemp.weeklyRate = null;
        priceQuoteReqTemp.weeklyTerm = null;
        priceQuoteReqTemp.cashPrice = null;
        priceQuoteReqTemp.spendLimitId = new URLSearchParams(window.location.search).get('spendLimitId');
        priceQuoteReqTemp.rmsPricingInfo = consolidateItemsByRmsNumber(searchResult.map((item: SearchResultItem) => ({
          rmsItemNumber: item.rmsItemNumber,
          modelNumber: item.modelNumber || null,
          weeklyRate: item.weeklyRate || null,
          weeklyTerm: item.weeklyTerm || null,
          cashPrice: item.cashPrice || null,
          costPerItem: item.costPerItem || null,
          qty: item.qty || item.quantity || '1',
        })));
        // Deduplicate rmsItemNumbers for validator uniqueItems constraint in LS flow
        priceQuoteReq.rmsItemNumbers = [...new Set(searchResult.map((obj: SearchResultItem) => obj.rmsItemNumber))];
      } else {
        priceQuoteReqTemp.weeklyRate = agreementRate ? agreementRate : searchResult[0].weeklyRate;
        priceQuoteReqTemp.weeklyTerm = agreementTerm ? agreementTerm : searchResult[0].weeklyTerm;
      }

      priceQuoteReqTemp.storeNumber = searchResult[0].storeNumber;
      priceQuoteReqTemp.customerId = customerId;
      let promodeCode = '';
      let configuredPromo = featureFlagDetails?.RafPromoCode?.split(',')??['RAF'];
      let isRafPromoEligible = configuredPromo.some((val)=> PromoCode?.toUpperCase()?.includes(val))
      let isLeadsReferral = PromoCode != undefined && ((rewardPromotion?.referralCode
          && PromoCode == rewardPromotion?.referralCode) || (isRafPromoEligible))
      // if ((customerReferralCode || isLeadsReferral) && featureFlagDetails.EnableRewardPromotion == '1') {
      //   setRewardEntered(customerReferralCode ? customerReferralCode : PromoCode);
      //   setofferCodeValue('referral');
      //   promodeCode = 'referral';
      //   priceQuoteReqTemp.promoCode = customerReferralCode ? customerReferralCode : PromoCode
      // }
      if (isCOReferralEnabled && (customerReferralCode || isLeadsReferral)) {
        setRewardEntered(customerReferralCode ? customerReferralCode : PromoCode);
        setofferCodeValue('referral');
        promodeCode = 'referral';
        priceQuoteReqTemp.promoCode = customerReferralCode ? customerReferralCode : PromoCode
      }
      else if (featureFlagDetails?.EnableCustomerTierReward == '1' && customerTierDetails?.memberStatus == 'Active') {
        if (!customerId) {
          console.error('Current customer ID is undefined');
        }
        rewards(priceQuoteReqTemp)
        // Do not let a disabled sales-lead Referral override an auto-selected tier promotion.
        if(salesLeadId && PromoCode && (isCOReferralEnabled || !isLeadsReferral)){
          setofferCodeValue(PromoCode)
          priceQuoteReqTemp.promoCode = PromoCode
          priceQuoteReqTemp.customerTier = customerTierDetails?.memberTiers?.loyaltyMemberTier
        }
        priceQuoteReqTemp.customerTier = customerTierDetails?.memberTiers?.loyaltyMemberTier
      }
      // Allow normal sales-lead promotions, but omit RAF/Referral when disabled for Customer Orders.
      else
        priceQuoteReqTemp.promoCode =
          salesLeadId && (isCOReferralEnabled || !isLeadsReferral)
            ? PromoCode
            : null;

      if (salesLeadData?.promoCode && salesLeadData?.promoNumber) {
        const filterPromo = customerPromotions?.promotions?.some(
          (ele) => {
            return ele.promotionCode == PromoCode || ele.promotionNumber == PromoCode;
          }
        );

        if (!filterPromo) {
          priceQuoteReqTemp.promoCode = null
        }
      }

      priceQuoteReqTemp.schedule = null;
      priceQuoteReqTemp.isLDWApplied = true;
      priceQuoteReqTemp.isClubApplied = true;
      // For LS initial flow (null pricing at parent level), cashPrice must stay null
      // so the BE accumulation logic triggers. Only set it for non-LS or subsequent LS calls.
      if (!isLocalSourcingFlow || agreementRate) {
        priceQuoteReqTemp.cashPrice = searchResult[0]?.cashPrice;
      }
      console.log('priceQuoteReqTemp', priceQuoteReqTemp);
      seterrbackupVal(priceQuoteReqTemp?.promoCode);
      const initialPageload = async () => {
        const getCOpriceQuoteResponse = await getCOpriceQuote(
          priceQuoteReqTemp
        );
        setpageLoading(false);
        setscheduleLoading(false);
        console.log('getCOpriceQuoteResponse', getCOpriceQuoteResponse);
        const getCOpriceQuoteData = getCOpriceQuoteResponse.data;
        //update
        if (getCOpriceQuoteResponse.status == 200) {
          setAgrSourceDisable(true);
          setagreementSourceValue(isLocalSourcingFlow ? 'LSRC' : 'SPOR');
          setpriceQuoteRes(getCOpriceQuoteResponse.data);
          setdropdownLoading(false);
          seteditDisableMode(false);
          GetPriceQuoteValueBind(getCOpriceQuoteData);
          // DE enforcement baseline: preserve baseline from ItemSearch if present, or set from initial price quote.
          setDeEnforcementBaseline((prev: any) => ({
            agreementRate: prev?.agreementRate ?? toFiniteNumber(getCOpriceQuoteData?.paymentSchedule?.weeklyRate),
            agreementTerm: prev?.agreementTerm ?? toFiniteNumber(getCOpriceQuoteData?.paymentSchedule?.weeklyTerm),
            sacTotal: prev?.sacTotal ?? toFiniteNumber(getCOpriceQuoteData?.agreementTotalPayment?.sacTotal ?? getCOpriceQuoteData?.agreementTotalPayment?.cashPrice),
            totalCost: prev?.totalCost ?? toFiniteNumber(getCOpriceQuoteData?.agreementTotalPayment?.totalCost),
          }));
          // Local Sourcing: Update context with populated pricing from backend response
          // This ensures subsequent requests use populated values and avoid redundant per-item recalculation
          if (isLocalSourcingFlow && getCOpriceQuoteData?.paymentSchedule) {
            const populatedWeeklyRate = getCOpriceQuoteData.paymentSchedule.weeklyRate;
            const populatedWeeklyTerm = getCOpriceQuoteData.paymentSchedule.weeklyTerm;
            const populatedCashPrice = getCOpriceQuoteData.agreementTotalPayment?.cashPrice;
            if (populatedWeeklyRate && populatedWeeklyTerm) {
              // Update the request object for any subsequent calls within this session
              priceQuoteReqTemp.weeklyRate = populatedWeeklyRate;
              priceQuoteReqTemp.weeklyTerm = populatedWeeklyTerm;
              priceQuoteReqTemp.cashPrice = populatedCashPrice || priceQuoteReqTemp.cashPrice;

              // Set aggregated pricing on searchResult[0] so subsequent calls
              // use the else branch (populated values) instead of sending rmsPricingInfo again.
              if (searchResult && searchResult.length > 0) {
                searchResult[0].weeklyRate = populatedWeeklyRate;
                searchResult[0].weeklyTerm = populatedWeeklyTerm;
                searchResult[0].cashPrice = populatedCashPrice || searchResult[0].cashPrice;
              }

              console.log('[LS] Pricing populated from backend - weeklyRate:', populatedWeeklyRate,
                'weeklyTerm:', populatedWeeklyTerm, 'cashPrice:', populatedCashPrice);
            }
          }

          if (getCOpriceQuoteResponse?.data?.promoEngineResponse?.promotionCode || getCOpriceQuoteResponse?.data?.promoEngineResponse?.promotionNumber) {
            setTierPromotionsValue(getCOpriceQuoteResponse?.data?.promoEngineResponse)
          }
          else {
            setTierPromotionsValue('')
          }
          if (getCOpriceQuoteData.employerPayschedule !== undefined) {
            if (
              getCOpriceQuoteData.employerPayschedule.schedule !== undefined &&
              getCOpriceQuoteData.employerPayschedule.daysPaid !== undefined
            ) {
              setpaymentScheduleEnabled(true);
              if (
                getCOpriceQuoteData.employerPayschedule.schedule.includes(
                  'Semi-Monthly'
                ) ||
                getCOpriceQuoteData.employerPayschedule.schedule.includes(
                  'Monthly'
                )
              ) {
                if (
                  getCOpriceQuoteData.employerPayschedule.daysPaid?.includes('&')
                ) {
                  const arr =
                    getCOpriceQuoteData.employerPayschedule.daysPaid?.split('&');
                  const convertedPayschedule =
                    Addsuffix(arr[0]) + ((language == 'es-MX' || language == 'es-US') ? ' y ' : ' & ')  + Addsuffix(arr[1]);
                  setpayschedule({
                    ...payschedule,
                    PayschedulePeriod:
                      getCOpriceQuoteData.employerPayschedule.schedule,
                    PayscheduleDay: convertedPayschedule,
                  });
                } else {
                  setpayschedule({
                    ...payschedule,
                    PayschedulePeriod:
                      getCOpriceQuoteData.employerPayschedule.schedule,
                    PayscheduleDay: Addsuffix(
                      getCOpriceQuoteData.employerPayschedule.daysPaid
                    ),
                  });
                }
              } else {
                setpayschedule({
                  ...payschedule,
                  PayschedulePeriod:
                    getCOpriceQuoteData.employerPayschedule.schedule,
                  PayscheduleDay:
                    getCOpriceQuoteData.employerPayschedule.daysPaid,
                });
              }
            } else {
              setpaymentScheduleEnabled(false);
            }
          }
          if (getCOpriceQuoteData.agreementSchedule.schedule.includes('SEMI')) {
            setrangeactive(true);
            setscheduleValue('SEMI1-15');
            setselectedSchedule({
              ...selectedSchedule,
              WeeklySchedule: false,
              BiWeeklySchedule: false,
              MonthlySchedule: false,
              SemiMonthlySchedule: true,
            });
            settermValue(getCOpriceQuoteData.paymentSchedule.semimonthlyTerm);
          } else {
            setrangeactive(false);
            setscheduleValue(getCOpriceQuoteData.agreementSchedule.schedule);
            setselectedSchedule({
              ...selectedSchedule,
              WeeklySchedule:
                getCOpriceQuoteData.agreementSchedule.schedule == 'WK'
                  ? true
                  : false,
              BiWeeklySchedule:
                getCOpriceQuoteData.agreementSchedule.schedule == 'BIWK'
                  ? true
                  : false,
              MonthlySchedule:
                getCOpriceQuoteData.agreementSchedule.schedule == 'MON'
                  ? true
                  : false,
              SemiMonthlySchedule: false,
            });
            if (getCOpriceQuoteData.agreementSchedule.schedule == 'WK') {
              settermValue(getCOpriceQuoteData.paymentSchedule.weeklyTerm);
            } else if (
              getCOpriceQuoteData.agreementSchedule.schedule == 'BIWK'
            ) {
              settermValue(getCOpriceQuoteData.paymentSchedule.biweeklyTerm);
            } else if (
              getCOpriceQuoteData.agreementSchedule.schedule == 'MON'
            ) {
              settermValue(getCOpriceQuoteData.paymentSchedule.monthlyTerm);
            }
          }
          createAgreementReqTemp.warehouseNumber = searchResult[0].wareHouseId;
          // createAgreementReqTemp.orderType = '1';
          createAgreementReqTemp.fees =
            getCOpriceQuoteData.agreementInitialPayment.totalFeesAmount ==
              '0.00'
              ? null
              : [
                {
                  feeAmount:
                    getCOpriceQuoteData.agreementInitialPayment
                      .totalFeesAmount,
                  feeType: 'PROC',
                  feeAmountTax: getCOpriceQuoteData?.agreementInitialPayment
                    ?.totalFeesAmountTax
                },
              ];
          createAgreementReqTemp.storeNumber =
            window.sessionStorage.getItem('storeNumber');
          if (coCustomerId) {
            createAgreementReqTemp.customer = [
              {
                customerId: customerId,
                priority: 1,
              },
              {
                customerId: coCustomerId,
                priority: 2,
              },
            ];
          } else {
            createAgreementReqTemp.customer = [
              {
                customerId: customerId,
                priority: 1,
              },
            ];
          }

          createAgreementReqTemp.hubStoreNumber =
            window.sessionStorage.getItem('storeNumber');
          setIsLdwTiedWithClub(
            getCOpriceQuoteData.storeCoverageStatus.isLdwTiedWithClub
          );
          setLDWstatus(
            getCOpriceQuoteData.customerCoverages.previousAgreementsLdwStatus
          );
          const CustomerCoverageObj: any = {
            storeCoverageStatus: getCOpriceQuoteData.storeCoverageStatus,
            clubInfo: getCOpriceQuoteData.customerCoverages,
          };
          setCustomerCoverageData(CustomerCoverageObj);
          setClubStatus(getCOpriceQuoteData.customerCoverages.clubStatus);
          setClubOriginStore(
            getCOpriceQuoteData.customerCoverages.clubOriginStore
          );
          if (
            CLUB_STATUS_ACTIVE_PENDING.includes(
              getCOpriceQuoteData.customerCoverages.clubStatus
            ) ||
            getCOpriceQuoteData.storeCoverageStatus.clubOnAgreementCreation ===
            false
          ) {
            priceQuoteReq.isClubApplied = false;
            createAgreementReqTemp.isClubApplied = false;
          }
          if (getCOpriceQuoteData.storeCoverageStatus.isLDWAllowed === false) {
            priceQuoteReq.isLDWApplied = false;
            createAgreementReqTemp.isLDWApplied = false;
          }
          if (
            getCOpriceQuoteData.storeCoverageStatus.isLdwTiedWithClub ===
            true &&
            priceQuoteReq.isLDWApplied === false
          ) {
            priceQuoteReq.isClubApplied = false;
            createAgreementReqTemp.isClubApplied = false;
          }
          setcreateAgreementReq(createAgreementReqTemp);
          const GenerateAgrReq: any = {};
          GenerateAgrReq.signingUrlRequired = false;
          GenerateAgrReq.signers = [];
          GenerateAgrReq.documentType = [];
          GenerateAgrReq.returnURL = window.location.origin;
          setGenerateDocReq(GenerateAgrReq);
          if (promodeCode == 'referral' && priceQuoteReqTemp?.promoCode != null && featureFlagDetails?.EnableRewardPromotion == '1') {
            setRewardAppliedPriceQuoteAmount(getCOpriceQuoteData?.agreementInitialPayment?.rewardsAmountUsed ?? '0.00');
            rewardPromoErrorMessageHandling(getCOpriceQuoteResponse);
          }

        } else {
          if (promodeCode == 'referral' && priceQuoteReqTemp?.promoCode != null && featureFlagDetails?.EnableRewardPromotion == '1') {
            //setdropdownLoading(false)
            rewardPromoErrorMessageHandling(getCOpriceQuoteResponse);
            setCustomerReferralCode(undefined);
            setRewardPromotion(undefined);
            setofferCodeValue('');
            setRewardEntered('');
            priceQuoteReqTemp.promoCode= '';
            initialPageload();
          }
          else
            setsomethingWentWrong(true);
        }
        //Dropdown formation starts here
        const AgrSourceArray = agreementOptions.agreementSource.map(
          (ele: any) => {
            return { value: ele.refCode, label: ((language == 'es-US' || language == 'es-MX') ? ele.descSpanish: ele.desc)  };
          }
        );
        AgrSourceArray.splice(0, 0, defaultDropdownValue);
        const SalesPersonArray = agreementOptions.salesPerson.map(
          (ele: any) => {
            return { value: ele.id.toString(), label: ele.name };
          }
        );
        SalesPersonArray.splice(0, 0, defaultDropdownValue);
        let RawOptionalService = agreementOptions.optServices;
        if (
          CLUB_STATUS_ACTIVE_PENDING.includes(
            getCOpriceQuoteData.customerCoverages.clubStatus
          ) ||
          !getCOpriceQuoteData.storeCoverageStatus.clubOnAgreementCreation
        ) {
          RawOptionalService = RawOptionalService.filter(
            (item) => item.refCode != 'BPC' && item.refCode != 'LDWC'
          );
        }
        if (!getCOpriceQuoteData.storeCoverageStatus.isLDWAllowed) {
          RawOptionalService = RawOptionalService.filter(
            (item) => item.refCode != 'LDW' && item.refCode != 'LDWC'
          );
        }
        if (getCOpriceQuoteData.storeCoverageStatus.isLdwTiedWithClub) {
          RawOptionalService = RawOptionalService.filter(
            (item) => item.refCode != 'BPC'
          );
        }
        console.log('Filtered Optional service', RawOptionalService);
        const optSerArray = RawOptionalService.map((ele: any) => {
          return { value: ele.refCode, label: ((language == 'es-US' || language == 'es-MX') ? ele.descSpanish: ele.desc)  };
        });
        optSerArray.splice(0, 0, defaultDropdownValue);
        const LDWcheck: any = optSerArray.filter((ele) => ele.value === 'LDW');
        const LDWCcheck: any = optSerArray.filter(
          (ele) => ele.value === 'LDWC'
        );

        if (LDWcheck.length > 0 && LDWCcheck.length === 0) {
          console.log('LDW alone check');
          setoptServiceValue('LDW');
        }
        if (LDWCcheck.length > 0) {
          console.log('LDWith club alone check');
          setoptServiceValue('LDWC');
        }
        if (LDWcheck.length === 0 && LDWCcheck.length === 0) {
          setoptServiceValue('NONE');
        }
        const filterCOPromoCode = agreementOptions.storePromotions.filter(
          (ele) => ele.customerOrderEnabled == 1
        );
        // Validate sales lead promo code against store promotions
        if (salesLeadData?.promoCode || salesLeadData?.promoNumber) {
          const storePromoExists: boolean = filterCOPromoCode?.some(
            (ele) => ele.promotionCode == PromoCode
          );
          
          if (!storePromoExists) {
            priceQuoteReqTemp.promoCode = null
          }
        }
        
        if (PromoCode && salesLeadId) {
          let filterPromo: boolean = false

          // Check in store promotions
          filterPromo = filterCOPromoCode.some(
            (ele) => ele.promotionCode == PromoCode
          );

          // Check in customer promotions
          if (!filterPromo) {
            // First check if it's a textbox promo
            const textBoxPromoMatch = customerPromotions?.promotions?.find(
              (ele) => ele.isTextBoxPromotion === 'Y' && (ele.promotionCode == PromoCode || ele.promotionNumber == PromoCode)
            );
            if (textBoxPromoMatch) {
              // Prepopulate textbox with the promo code
              setPromoTextInput(textBoxPromoMatch.promotionCode);
              setofferCodeValue(textBoxPromoMatch.promotionNumber);
              filterPromo = true;
            } else {
              // Check in dropdown promos (isTextBoxPromotion !== 'Y')
              filterPromo = customerPromotions?.promotions
                ?.filter((ele) => ele.isTextBoxPromotion !== 'Y')
                ?.some(
                  (ele) => {
                    return ele.promotionCode == PromoCode || ele.promotionNumber == PromoCode;
                  }
                );
            }
          }

          if (filterPromo === true && !promoTextInput) {
            setofferCodeValue(PromoCode);
          }
        }
        const PromoCodeOptionsArray: any = filterCOPromoCode.map((ele: any) => {
          return { value: ele.promotionCode, label: ele.promotionName };
        });

        PromoCodeOptionsArray.splice(0, 0, defaultDropdownValue);

        if (featureFlagDetails?.AllowCustomerTierPromocode === '1' && customerPromotions?.promotions?.length > 0) {
          const customerStatePromotions = customerPromotions.promotions
            .filter((e) => e.isTextBoxPromotion !== 'Y')
            .map((e) => {
              return { value: e.promotionNumber, label: e.promotionCode };
            });

          PromoCodeOptionsArray.splice(1, 0, ...customerStatePromotions);
        }

        const filterCOCustPromos = agreementOptions.customerPromotions?.filter(
          (ele) => Number(ele.customerOrderEnabled) == 1
        );

        if (filterCOCustPromos != undefined && filterCOCustPromos.length > 0) {
          const customerPromotions = filterCOCustPromos.map((e: any) => {
            return { value: e.promotionCode, label: e.promotionName };
          })
          console.log('customerPromotions', customerPromotions);
          PromoCodeOptionsArray.push(...customerPromotions);
        }

        if (isCOReferralEnabled) {
          const refferalObj = { value: 'referral', label: 'Referral' }
          PromoCodeOptionsArray.push(refferalObj)
        }

        const RangeRawValueArray = agreementOptions.schedule.filter(
          (word) => word.desc === 'Semi-Monthly' && word.refCode !== 'SEMI'
        );
        const SortRangeRawValueArray = RangeRawValueArray.sort(
          (a, b) => parseInt(a.displaySeq) - parseInt(b.displaySeq)
        );
        const Rangeval = SortRangeRawValueArray.map((ele: any) => {
          const value = ele.refCode;
          const tempval = value.replace(/SEMI/g, '');
          const tempArr = tempval.split('-');
          const finalrange =
            Addsuffix(tempArr[0]) + ' ' + Addsuffix(tempArr[1]);
          return { value: ele.refCode, label: t(finalrange) };
        });
        const UniqScheduleOptions = agreementOptions.schedule.filter(
          (value, index, self) =>
            index === self.findIndex((t) => t.desc === value.desc)
        );
        const ScheduleArray = UniqScheduleOptions.map((ele) => {
          let value = ele.refCode;
          if (ele.desc === 'Semi-Monthly') {
            value = 'SEMI1-15';  
          }
          return {
            value: value,
            label: ((language == 'es-US' || language == 'es-MX') ? ele.descSpanish : ele.desc)
          };
        });
        setscheduleOptions(ScheduleArray);
        setrangeOptions(Rangeval);
        setagreementSourceOptions(AgrSourceArray);
        setofferCodeOptions(PromoCodeOptionsArray);
        setoptServiceOptions(optSerArray);
        setsalesPersonOptions(SalesPersonArray);
      };
      const initializeCustomerOrderDetails = async () => {
        await initialPageload();
      };
      initializeCustomerOrderDetails();
    } else if (wholeAgrInfoResponse) {
      console.log('2h9whole', wholeAgrInfoResponse);
      setprocessFeeDisable(true);
      seteditDisableMode(true);
      setpageLoading(false);
      setscheduleLoading(false);
      setdropdownLoading(false);
      setAgrCustomerObj(wholeAgrInfoResponse.customers);
      const AgrCustomers = wholeAgrInfoResponse.customers;
      const Customerdata = AgrCustomers.customer.filter(
        (obj) => obj.priority == 1
      );
      console.log('Customerdata', Customerdata);

      const CustomerName =
        Customerdata[0].firstName + ' ' + Customerdata[0].lastName;
      if (AgrCustomers.customer.length == 1) {
        const AGreementDocObj: any = GenerateDocReq;
        const CustomerObj = [
          {
            customerId: Customerdata[0].customerId.toString(),
            customerName: CustomerName,
            phoneNumber: Customerdata[0]?.phoneNumbers ? Customerdata[0]?.phoneNumbers : Customerdata[0]?.phoneNumber,
            emailId: Customerdata[0].emailAddress,
            priority: 1,
          },
        ];

        console.log('PayloadForm', CustomerObj);
        setAgrCustomerObj(CustomerObj);
        AGreementDocObj.signers = CustomerObj;
        setGenerateDocReq(AGreementDocObj);
        //setcustomerSignatureEnabled(true);
      } else {
        const AGreementDocObj: any = GenerateDocReq;
        const CoCustomer = AgrCustomers.coCustomer?.filter(
          (obj) => obj.priority == 2
        );
        const CoCustomerName =
          CoCustomer[0].firstName + ' ' + CoCustomer[0].lastName;
        const CustomerObj = [
          {
            customerId: Customerdata[0].customerId.toString(),
            customerName: CustomerName,
            phoneNumber: Customerdata[0]?.phoneNumbers ? Customerdata[0]?.phoneNumbers : Customerdata[0]?.phoneNumber,
            emailId: Customerdata[0].emailAddress,
            priority: 1,
          },
          {
            customerId: CoCustomer[0].customerId.toString(),
            customerName: CoCustomerName,
            phoneNumber: CoCustomer[0]?.phoneNumbers ? CoCustomer[0]?.phoneNumbers : CoCustomer[0]?.phoneNumber,
            emailId: CoCustomer[0].emailAddress,
            priority: 2,
          },
        ];
        setAgrCustomerObj(CustomerObj);
        AGreementDocObj.signers = CustomerObj;
        setGenerateDocReq(AGreementDocObj);
        //setcustomerSignatureEnabled(true);
      }
      const AgreementDocReq: any = GenerateDocReq;
      AgreementDocReq.identifier = parseInt(wholeAgrInfoResponse.agreementId);
      AgreementDocReq.identifierType = 'AGR';
      AgreementDocReq.signatureType = 1;
      AgreementDocReq.isRemote = false;
      AgreementDocReq.manualSignatureReasonId = null;
      if (AgrCustomers.customer.length === 1) {
        const CustomerObj = [
          {
            customerId: Customerdata[0].customerId.toString(),
            customerName: CustomerName,
            phoneNumber:
              Customerdata[0].phoneNumber !== null
                ? Customerdata[0].phoneNumber
                : '1111111111',
            emailId:
              Customerdata[0].emailAddress !== null
                ? Customerdata[0].emailAddress
                : 'test@example.com',
            priority: 1,
          },
        ];
        AgreementDocReq.signers = CustomerObj;
      } else {
        const CoCustomer = AgrCustomers.coCustomer?.filter(
          (obj) => obj.priority == 2
        );
        const CoCustomerName =
          CoCustomer[0].firstName + ' ' + CoCustomer[0].lastName;

        const CustomerObj = [
          {
            customerId: Customerdata[0].customerId.toString(),
            customerName: CustomerName,
            phoneNumber:
              Customerdata[0].phoneNumber !== null
                ? Customerdata[0].phoneNumber
                : '1111111111',
            emailId:
              Customerdata[0].emailAddress !== null
                ? Customerdata[0].emailAddress
                : 'test@example.com',
            priority: 1,
          },
          {
            customerId: CoCustomer[0].customerId.toString(),
            customerName: CoCustomerName,
            phoneNumber:
              CoCustomer[0].phoneNumber !== null
                ? CoCustomer[0].phoneNumber
                : '1111111111',
            emailId:
              CoCustomer[0].emailAddress !== null
                ? CoCustomer[0].emailAddress
                : 'test@example.com',
            priority: 2,
          },
        ];
        AgreementDocReq.signers = CustomerObj;
      }
      // if (AutoPayToggleStatus !== true) {
      //   setAutoPayOpen(true);
      // } else {
      //   setcustomerSignatureEnabled(true);
      // }
      //setPreviousBtnDisabled(true);
      // const generate = async () => {
      //   const GenerateAgreementDocRes = await GenerateAgreementDoc(
      //     AgreementDocReq
      //   );
      //   console.log(
      //     'First Generate Agreement Call response',
      //     GenerateAgreementDocRes
      //   );
      // };
      // generate();
      setdocumentGenerateCompleted(true);
      setItemSearchCompleted(true);
      setPopupCompleteStatus({
        ...PopupCompleteStatus,
        CustomerSignComplete:
          wholeAgrInfoResponse.agreementWorkflow.isAgreementSigned == '1',
        PrelimpaymentPaymentComplete:
          wholeAgrInfoResponse.agreementWorkflow.isPreliminaryPaymentPaid ==
          '1',
        InitialPaymentComplete:
          wholeAgrInfoResponse.agreementWorkflow.isInitialPaymentPaid == '1',
        AgreementCreated: true,
        AgreementStatus:
          wholeAgrInfoResponse?.generalInformation?.agreementStatus,
      });
      GetPriceQuoteValueBind(wholeAgrInfoResponse);
      if (wholeAgrInfoResponse.employerPayschedule !== undefined) {
        if (
          wholeAgrInfoResponse.employerPayschedule.schedule &&
          wholeAgrInfoResponse.employerPayschedule.daysPaid
        ) {
          setpaymentScheduleEnabled(true);
          if (
            wholeAgrInfoResponse.employerPayschedule.schedule.includes(
              'Semi-Monthly'
            ) ||
            wholeAgrInfoResponse.employerPayschedule.schedule.includes(
              'Monthly'
            )
          ) {
            if (
              wholeAgrInfoResponse.employerPayschedule.daysPaid.includes('&')
            ) {
              const arr =
                wholeAgrInfoResponse.employerPayschedule.daysPaid.split('&');
              const convertedPayschedule =
                Addsuffix(arr[0]) + ((language == 'es-MX' || language == 'es-US') ? ' y ' : ' & ')  + Addsuffix(arr[1]);
              setpayschedule({
                ...payschedule,
                PayschedulePeriod:
                  wholeAgrInfoResponse.employerPayschedule.schedule,
                PayscheduleDay: convertedPayschedule,
              });
            } else {
              setpayschedule({
                ...payschedule,
                PayschedulePeriod:
                  wholeAgrInfoResponse.employerPayschedule.schedule,
                PayscheduleDay: Addsuffix(
                  wholeAgrInfoResponse.employerPayschedule.daysPaid
                ),
              });
            }
          } else {
            setpayschedule({
              ...payschedule,
              PayschedulePeriod:
                wholeAgrInfoResponse.employerPayschedule.schedule,
              PayscheduleDay: wholeAgrInfoResponse.employerPayschedule.daysPaid,
            });
          }
        } else {
          setpaymentScheduleEnabled(false);
        }
      }
      if (wholeAgrInfoResponse.agreementSchedule.schedule.includes('SEMI')) {
        setrangeactive(true);
        setscheduleValue(wholeAgrInfoResponse.agreementSchedule.schedule);
        setrangeValue(wholeAgrInfoResponse?.agreementSchedule?.schedule)
        setselectedSchedule({
          ...selectedSchedule,
          WeeklySchedule: false,
          BiWeeklySchedule: false,
          MonthlySchedule: false,
          SemiMonthlySchedule: true,
        });
        settermValue(wholeAgrInfoResponse.paymentSchedule.semimonthlyTerm);
      } else {
        setrangeactive(false);
        setscheduleValue(wholeAgrInfoResponse.agreementSchedule.schedule);
        setselectedSchedule({
          ...selectedSchedule,
          WeeklySchedule:
            wholeAgrInfoResponse.agreementSchedule.schedule == 'WK'
              ? true
              : false,
          BiWeeklySchedule:
            wholeAgrInfoResponse.agreementSchedule.schedule == 'BIWK'
              ? true
              : false,
          MonthlySchedule:
            wholeAgrInfoResponse.agreementSchedule.schedule == 'MON'
              ? true
              : false,
          SemiMonthlySchedule: false,
        });
        if (wholeAgrInfoResponse.agreementSchedule.schedule == 'WK') {
          settermValue(wholeAgrInfoResponse.paymentSchedule.weeklyTerm);
        } else if (wholeAgrInfoResponse.agreementSchedule.schedule == 'BIWK') {
          settermValue(wholeAgrInfoResponse.paymentSchedule.biweeklyTerm);
        } else if (wholeAgrInfoResponse.agreementSchedule.schedule == 'MON') {
          settermValue(wholeAgrInfoResponse.paymentSchedule.monthlyTerm);
        }
      }
      const AgrSourceArray =
        wholeAgrInfoResponse.agreementOption.agreementSource.map((ele: any) => {
          return { value: ele.value, label: ele.label };
        });
      AgrSourceArray.splice(0, 0, defaultDropdownValue);
      const SalesPersonArray =
        wholeAgrInfoResponse.agreementOption.salesPerson.map((ele: any) => {
          return { value: ele.value.toString(), label: ele.label };
        });
      SalesPersonArray.splice(0, 0, defaultDropdownValue);
      const RawOptionalService =
        wholeAgrInfoResponse.agreementOption.optServices;
      console.log('Filtered Optional service', RawOptionalService);
      const optSerArray = RawOptionalService.map((ele: any) => {
        return { value: ele.value, label: ele.label };
      });
      optSerArray.splice(0, 0, defaultDropdownValue);
      const PromoCodeOptionsArray: any =
        wholeAgrInfoResponse.agreementOption.promoCode?.map((ele: any) => {
          return { value: ele.value, label: ele.label };
        });
      PromoCodeOptionsArray?.splice(0, 0, defaultDropdownValue);
      const RangeRawValueArray =
        wholeAgrInfoResponse.agreementOption.schedule.filter(
          (word) => word.label === 'Semi-Monthly' && word.value !== 'SEMI'
        );
      // eslint-disable-next-line sonarjs/no-identical-functions
      const Rangeval = RangeRawValueArray?.map((ele: any) => {
        const value = ele.value;
        const tempval = value.replace(/SEMI/g, '');
        const tempArr = tempval.split('-');
        const finalrange = Addsuffix(tempArr[0]) + ' ' + Addsuffix(tempArr[1]);
        return { value: ele.value, label: t(finalrange) };
      });
      setscheduleOptions(wholeAgrInfoResponse.agreementOption.schedule);
      setrangeOptions(Rangeval);
      setagreementSourceOptions(
        wholeAgrInfoResponse.agreementOption.agreementSource
      );
      const LDWcheck: any =
        wholeAgrInfoResponse.agreementOption.optServices.filter(
          (ele) => ele.value === 'LDW'
        );
      const LDWCcheck: any =
        wholeAgrInfoResponse.agreementOption.optServices.filter(
          (ele) => ele.value === 'LDWC'
        );
      if (LDWcheck.length > 0 && LDWCcheck.length === 0) {
        console.log('LDW alone check');
        setoptServiceValue('LDW');
      }
      if (LDWCcheck.length > 0) {
        console.log('LDWith club alone check');
        setoptServiceValue('LDWC');
      }
      if (LDWcheck.length === 0 && LDWCcheck.length === 0) {
        setoptServiceValue('NONE');
      }
      setAgrSourceDisable(true);
      setagreementSourceValue('SPOR');
      setAgreementId(wholeAgrInfoResponse.agreementId);
      setofferCodeOptions(PromoCodeOptionsArray);
      setoptServiceOptions(wholeAgrInfoResponse.agreementOption.optServices);
      setsalesPersonOptions(SalesPersonArray);
      wholeAgrInfoResponse.agreementOption.salesPerson.map((el: any) => {
        setsalesPersonValue(el.value);
      });
      if (wholeAgrInfoResponse.generalInformation.agreementStatusRefCode == 'PRELIMCANC') {
        setnextBtnDisabled(true);
      }
      else {
        setnextBtnDisabled(false);
      }
    } else if (agreementId) {
      console.log('2h9whole', wholeAgrInfoResponse);
      setprocessFeeDisable(true);
      const AgrInfoResponse = async () => {
        seteditDisableMode(true);
        setpageLoading(true);
        setscheduleLoading(true);
        setdropdownLoading(true);
        const result = await getAgreementInfo(agreementId);
        if (result.status == 200) {
          const FormatResponse = SetPendingCOAgreementValue(result?.data);
          setwholeAgrInfoResponse(FormatResponse);
          const rmsItemInformation = result?.data?.agreementInventories.map(
            (el: any) => {
              return {
                modelNumber: el.modelNumber,
                brand: el.brand,
                cashPrice: result?.data?.totalPayment.cashPrice,
                department: el.department,
                subdepartment: el.subDepartment,
                monthlyRate: el.agreementRate,
                monthlyTerm: el.agreementTerm,
                totalCost: el.agreementTotal,
                availability: null,
              };
            }
          );
          const rmsItemObj = {
            rmsItemInformation: rmsItemInformation,
          };
          setagreementCreateStatus({ agreementCreatedStatus: true });
          setIsAllDone(true);
          setsearchResult(rmsItemObj.rmsItemInformation);
          if (FormatResponse) {
            seteditDisableMode(true);
            setpageLoading(false);
            setscheduleLoading(false);
            setdropdownLoading(false);
            setAgrCustomerObj(FormatResponse.customers);
            const AgrCustomers = FormatResponse.customers;
            const Customerdata = AgrCustomers.customer.filter(
              (obj) => obj.priority == 1
            );
            console.log('Customerdata', Customerdata);
            const CustomerName =
              Customerdata[0].firstName + ' ' + Customerdata[0].lastName;
            if (AgrCustomers.customer.length == 1) {
              const AGreementDocObj: any = GenerateDocReq;
              const CustomerObj = [
                {
                  customerId: Customerdata[0].customerId.toString(),
                  customerName: CustomerName,
                  phoneNumber: Customerdata[0]?.phoneNumbers ? Customerdata[0]?.phoneNumbers : Customerdata[0]?.phoneNumber,
                  emailId: Customerdata[0].emailAddress,
                  priority: 1,
                },
              ];
              console.log('PayloadForm', CustomerObj);
              setAgrCustomerObj(CustomerObj);
              AGreementDocObj.signers = CustomerObj;
              setGenerateDocReq(AGreementDocObj);
              //setcustomerSignatureEnabled(true);
            } else {
              const AGreementDocObj: any = GenerateDocReq;
              const CoCustomer = AgrCustomers.coCustomer?.filter(
                (obj) => obj.priority == 2
              );
              const CoCustomerName =
                CoCustomer[0].firstName + ' ' + CoCustomer[0].lastName;
              const CustomerObj = [
                {
                  customerId: Customerdata[0].customerId.toString(),
                  customerName: CustomerName,
                  phoneNumber: Customerdata[0]?.phoneNumbers ? Customerdata[0]?.phoneNumbers : Customerdata[0]?.phoneNumber,
                  emailId: Customerdata[0].emailAddress,
                  priority: 1,
                },
                {
                  customerId: CoCustomer[0].customerId.toString(),
                  customerName: CoCustomerName,
                  phoneNumber: CoCustomer[0]?.phoneNumbers ? CoCustomer[0]?.phoneNumbers : CoCustomer[0]?.phoneNumber,
                  emailId: CoCustomer[0].emailAddress,
                  priority: 2,
                },
              ];
              setAgrCustomerObj(CustomerObj);
              AGreementDocObj.signers = CustomerObj;
              setGenerateDocReq(AGreementDocObj);
              //setcustomerSignatureEnabled(true);
            }
            const AgreementDocReq: any = GenerateDocReq;
            AgreementDocReq.identifier = parseInt(FormatResponse.agreementId);
            AgreementDocReq.identifierType = 'AGR';
            AgreementDocReq.signatureType = 1;
            AgreementDocReq.isRemote = false;
            AgreementDocReq.manualSignatureReasonId = null;
            if (AgrCustomers.customer.length === 1) {
              const CustomerObj = [
                {
                  customerId: Customerdata[0].customerId.toString(),
                  customerName: CustomerName,
                  phoneNumber:
                    Customerdata[0].phoneNumber !== null
                      ? Customerdata[0].phoneNumber
                      : '1111111111',
                  emailId:
                    Customerdata[0].emailAddress !== null
                      ? Customerdata[0].emailAddress
                      : 'test@example.com',
                  priority: 1,
                },
              ];
              AgreementDocReq.signers = CustomerObj;
            } else {
              const CoCustomer = AgrCustomers.coCustomer?.filter(
                (obj) => obj.priority == 2
              );
              const CoCustomerName =
                CoCustomer[0].firstName + ' ' + CoCustomer[0].lastName;
              const CustomerObj = [
                {
                  customerId: Customerdata[0].customerId.toString(),
                  customerName: CustomerName,
                  phoneNumber:
                    Customerdata[0].phoneNumber !== null
                      ? Customerdata[0].phoneNumber
                      : '1111111111',
                  emailId:
                    Customerdata[0].emailAddress !== null
                      ? Customerdata[0].emailAddress
                      : 'test@example.com',
                  priority: 1,
                },
                {
                  customerId: CoCustomer[0].customerId.toString(),
                  customerName: CoCustomerName,
                  phoneNumber:
                    CoCustomer[0].phoneNumber !== null
                      ? CoCustomer[0].phoneNumber
                      : '1111111111',
                  emailId:
                    CoCustomer[0].emailAddress !== null
                      ? CoCustomer[0].emailAddress
                      : 'test@example.com',
                  priority: 2,
                },
              ];
              AgreementDocReq.signers = CustomerObj;
            }
            // if (AutoPayToggleStatus !== true) {
            //   setAutoPayOpen(true);
            // } else {
            //   setcustomerSignatureEnabled(true);
            // }
            //setpreviousBtnDisabled(true);
            // eslint-disable-next-line sonarjs/no-identical-functions
            // const generate = async () => {
            //   const GenerateAgreementDocRes = await GenerateAgreementDoc(
            //     AgreementDocReq
            //   );
            //   console.log(
            //     'First Generate Agreement Call response',
            //     GenerateAgreementDocRes
            //   );
            // };
            // generate();
            setdocumentGenerateCompleted(true);
            setPopupCompleteStatus({
              ...PopupCompleteStatus,
              CustomerSignComplete:
                FormatResponse.agreementWorkflow.isAgreementSigned == '1',
              PrelimpaymentPaymentComplete:
                FormatResponse.agreementWorkflow.isPreliminaryPaymentPaid ==
                '1',
              InitialPaymentComplete:
                FormatResponse.agreementWorkflow.isInitialPaymentPaid == '1',
              AgreementCreated: true,
              AgreementStatus:
                FormatResponse?.generalInformation?.agreementStatus,
            });
            GetPriceQuoteValueBind(FormatResponse, rmsItemObj);
            if (FormatResponse.employerPayschedule !== undefined) {
              if (
                FormatResponse.employerPayschedule.schedule &&
                FormatResponse.employerPayschedule.daysPaid
              ) {
                setpaymentScheduleEnabled(true);
                if (
                  FormatResponse.employerPayschedule.schedule.includes(
                    'Semi-Monthly'
                  ) ||
                  FormatResponse.employerPayschedule.schedule.includes(
                    'Monthly'
                  )
                ) {
                  if (
                    FormatResponse.employerPayschedule.daysPaid.includes('&')
                  ) {
                    const arr =
                      FormatResponse.employerPayschedule.daysPaid.split('&');
                    const convertedPayschedule =
                      Addsuffix(arr[0]) + ((language == 'es-MX' || language == 'es-US') ? ' y ' : ' & ') + Addsuffix(arr[1]);
                    setpayschedule({
                      ...payschedule,
                      PayschedulePeriod:
                        FormatResponse.employerPayschedule.schedule,
                      PayscheduleDay: convertedPayschedule,
                    });
                  } else {
                    setpayschedule({
                      ...payschedule,
                      PayschedulePeriod:
                        FormatResponse.employerPayschedule.schedule,
                      PayscheduleDay: Addsuffix(
                        FormatResponse.employerPayschedule.daysPaid
                      ),
                    });
                  }
                } else {
                  setpayschedule({
                    ...payschedule,
                    PayschedulePeriod:
                      FormatResponse.employerPayschedule.schedule,
                    PayscheduleDay: FormatResponse.employerPayschedule.daysPaid,
                  });
                }
              } else {
                setpaymentScheduleEnabled(false);
              }
            }
            if (FormatResponse.agreementSchedule.schedule.includes('SEMI')) {
              setrangeactive(true);
              setscheduleValue(FormatResponse?.agreementSchedule?.schedule);
              setrangeValue(FormatResponse?.agreementSchedule?.schedule)
              setselectedSchedule({
                ...selectedSchedule,
                WeeklySchedule: false,
                BiWeeklySchedule: false,
                MonthlySchedule: false,
                SemiMonthlySchedule: true,
              });
              settermValue(FormatResponse.paymentSchedule.semimonthlyTerm);
            } else {
              setrangeactive(false);
              setscheduleValue(FormatResponse.agreementSchedule.schedule);
              setselectedSchedule({
                ...selectedSchedule,
                WeeklySchedule:
                  FormatResponse.agreementSchedule.schedule == 'WK'
                    ? true
                    : false,
                BiWeeklySchedule:
                  FormatResponse.agreementSchedule.schedule == 'BIWK'
                    ? true
                    : false,
                MonthlySchedule:
                  FormatResponse.agreementSchedule.schedule == 'MON'
                    ? true
                    : false,
                SemiMonthlySchedule: false,
              });
              if (FormatResponse.agreementSchedule.schedule == 'WK') {
                settermValue(FormatResponse.paymentSchedule.weeklyTerm);
              } else if (FormatResponse.agreementSchedule.schedule == 'BIWK') {
                settermValue(FormatResponse.paymentSchedule.biweeklyTerm);
              } else if (FormatResponse.agreementSchedule.schedule == 'MON') {
                settermValue(FormatResponse.paymentSchedule.monthlyTerm);
              }
            }
            const AgrSourceArray =
              FormatResponse.agreementOption.agreementSource.map((ele: any) => {
                return { value: ele.value, label: ele.label };
              });
            AgrSourceArray.splice(0, 0, defaultDropdownValue);
            const SalesPersonArray =
              FormatResponse.agreementOption.salesPerson.map((ele: any) => {
                return { value: ele.value.toString(), label: ele.label };
              });
            SalesPersonArray.splice(0, 0, defaultDropdownValue);
            const RawOptionalService =
              FormatResponse.agreementOption.optServices;
            console.log('Filtered Optional service', RawOptionalService);
            const optSerArray = RawOptionalService.map((ele: any) => {
              return { value: ele.value, label: ele.label };
            });
            optSerArray.splice(0, 0, defaultDropdownValue);
            const PromoCodeOptionsArray: any =
              FormatResponse.agreementOption.promoCode?.map((ele: any) => {
                return { value: ele.value, label: ele.label };
              });
            PromoCodeOptionsArray?.splice(0, 0, defaultDropdownValue);
            const RangeRawValueArray =
              FormatResponse.agreementOption.schedule.filter(
                (word) => word.label === 'Semi-Monthly' && word.value !== 'SEMI'
              );
            // eslint-disable-next-line sonarjs/no-identical-functions
            const Rangeval = RangeRawValueArray?.map((ele: any) => {
              const value = ele.value;
              const tempval = value.replace(/SEMI/g, '');
              const tempArr = tempval.split('-');
              const finalrange =
                Addsuffix(tempArr[0]) + ' ' + Addsuffix(tempArr[1]);
              return { value: ele.value, label: t(finalrange) };
            });
            setscheduleOptions(FormatResponse.agreementOption.schedule);
            setrangeOptions(Rangeval);
            setagreementSourceOptions(
              FormatResponse.agreementOption.agreementSource
            );
            const LDWcheck: any =
              FormatResponse.agreementOption.optServices.filter(
                (ele) => ele.value === 'LDW'
              );
            const LDWCcheck: any =
              FormatResponse.agreementOption.optServices.filter(
                (ele) => ele.value === 'LDWC'
              );
            if (LDWcheck.length > 0 && LDWCcheck.length === 0) {
              console.log('LDW alone check');
              setoptServiceValue('LDW');
            }
            if (LDWCcheck.length > 0) {
              console.log('LDWith club alone check');
              setoptServiceValue('LDWC');
            }
            if (LDWcheck.length === 0 && LDWCcheck.length === 0) {
              setoptServiceValue('NONE');
            }
            setAgrSourceDisable(true);
            setagreementSourceValue('SPOR');
            setAgreementId(FormatResponse.agreementId);
            setofferCodeOptions(PromoCodeOptionsArray);
            setoptServiceOptions(FormatResponse.agreementOption.optServices);
            setsalesPersonOptions(SalesPersonArray);
            FormatResponse.agreementOption.salesPerson.map((el: any) => {
              setsalesPersonValue(el.value);
            });
            if (FormatResponse.generalInformation.agreementStatusRefCode == 'PRELIMCANC') {
              setnextBtnDisabled(true);
            }
            else {
              setnextBtnDisabled(false);
            }
            //setnextBtnDisabled(false);
          }
        } else {
          setsomethingWentWrong(true);
        }
      };
      AgrInfoResponse();
    } else {
      if (!isLocalSourcingFlow) {
        setsomethingWentWrong(true);
      }
    }
    setpriceQuoteReq(priceQuoteReqTemp);
    const GettingRole = async () => {
      const GetcurrentUser = await GetEmployeeID();
      console.log('GetcurrentUser', GetcurrentUser);
      if (GetcurrentUser.status === 200) {
        const GetcurrentUserResponse = GetcurrentUser.data;
        const EmployeeId = GetcurrentUserResponse.employeeId;
        const GetMenuPayload = {
          coworkerId: EmployeeId,
        };
        const GetMenuDetails: any = await GetRole(GetMenuPayload);
        console.log('GetMenuDetails', GetMenuDetails);
        if (GetMenuDetails.status === 200) {
          const GetMenuDetailsResponse = GetMenuDetails.data;
          const currentRoleRes = GetMenuDetailsResponse.coworkerProfile.role;
          console.log('currentRole', currentRoleRes);
          setcurrentRole(currentRoleRes);
        }
      }
    };
    if (containerData !== undefined) {
      console.log('containerData', containerData);
      console.log('containerDataRole', containerData.GetRole());
      setcurrentRole(containerData.GetRole());
    } else {
      GettingRole();
    }
  }, [searchResult, agreementOptions]);

  const rewards = (priceQuoteReqTemp :any) => {
    try {
      const validCodesString = customerTierCodes
      const validCodes = validCodesString.split(',');

      const filteredPromotions = customerPromotions?.promotions?.filter((promotion: any) => {
        return validCodes.includes(promotion.promotionCode.toUpperCase());
      }) || [];

      setMatchingPromotions(filteredPromotions);
      console.log(filteredPromotions, 'matchingPromotions');

      const existingHistory = sessionStorage.getItem('customerHistory') ?? '';

      const customerHistory = JSON.parse(existingHistory);

      if (Array.isArray(customerHistory)) {
        if (customerHistory.includes(customerId)) {
          console.log("Customer has redeemed reward");

          if (
            filteredPromotions &&
            filteredPromotions.length > 0 &&
            filteredPromotions[0].promotionName
          ) {
            const promoCode = filteredPromotions[0].promotionCode;
            const promoNumber = filteredPromotions[0].promotionNumber;
            // setRewardEntered(promoCode)
            setofferCodeValue(promoNumber)
            // promodeCode = promoCode
            priceQuoteReqTemp.promoCode = promoNumber
          }
          return true;
        }
        return false;
      } else {
        console.error('Customer history in session storage is not an array');
        return false;
      }
    } catch (error) {
      console.error('Error parsing customer history from session storage:', error);
      return false;
    }
  }
  useEffect(() => {
    console.log('intialAmountCalc', intialAmountCalc);
    console.log('processingFee', processingFee);
    console.log('OtherAmt', OtherAmt);

    if (intialAmountCalc && processingFee != OtherAmt) {
      const calcFees: any = Number(
        Number(intialAmountCalc) -
        Number(Number(processingFee) - Number(OtherAmt))
      )?.toFixed(2);
      console.log('calcFees', calcFees);
      //const fees: any[] = []; //

      const fee: any = [
        {
          feeAmount: OtherAmt.toString(),
          feeType: 'PROC',
        },
      ];

      //fees.push(fee);
      setcreateAgreementReq({ ...createAgreementReq, fees: fee });
      setinitialPaymentAmount({
        ...initialPaymentAmount,
        InitialPayment: calcFees.toString(),
      });
    }
  }, [OtherAmt]);
  useEffect(() => {

    if (agreementId) {
      getAgreementInfoFn()

    }
  }, [])
  useEffect(() => {
    if (
      AgreementId !== undefined &&
      AgreementId !== null &&
      AgreementId !== ""
    ) {
      setVoidEnabled(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [AgreementId]);


  const getAgreementInfoFn = async () => {
    const getAgreementInfoFnRes = await getAgreementInfo(agreementId)
    if (getAgreementInfoFnRes.status == 200) {
      setgetAgreementInfoRes(getAgreementInfoFnRes?.data)
      const agreementInfo = getAgreementInfoFnRes?.data;
      setPromoCode(agreementInfo?.agreementInformation?.promoCode || '');
      const promoArray: any = [{
        value: '',
        label: t('Select')
      }, {
        value: agreementInfo?.agreementInformation?.promoCode,
        label: agreementInfo?.agreementInformation?.promoCode
      }]
      setPromoCodeOptions(promoArray || []);
    }
  }
  const GetPriceQuoteValueBind = (getCOpriceQuoteData: any, value?: any) => {
    if (searchResult != undefined) {
      setpaymentScheduleValues(getCOpriceQuoteData.paymentSchedule);
      setinitialPaymentAmount({
        ...initialPaymentAmount,
        Club: getCOpriceQuoteData.agreementInitialPayment.clubAmount,
        LDW: getCOpriceQuoteData.agreementInitialPayment.ldw,
        Tax: getCOpriceQuoteData.agreementInitialPayment.totalTax,
        Rate: getCOpriceQuoteData.agreementInitialPayment.initialRate,
        InitialPayment:
          getCOpriceQuoteData.agreementInitialPayment.initialPayment,
      });
      setprocessingFee(
        getCOpriceQuoteData.agreementInitialPayment.totalFeesAmount
      );
      setwlDeposit(getCOpriceQuoteData.agreementInitialPayment?.webLeadDeposit);
      setInitialAmountCalc(
        getCOpriceQuoteData.agreementInitialPayment.initialPayment
      );
      settotalPaymentAmount({
        ...totalPaymentAmount,
        InitialPayment:
          getCOpriceQuoteData.agreementTotalPayment.initialPaymentTotal,
        RegularPayments:
          getCOpriceQuoteData.agreementTotalPayment.regularPaymentsAmount,
        RegularPaymentsTerm:
          getCOpriceQuoteData.agreementTotalPayment.regularPaymentsCount,
        FinalPayment: getCOpriceQuoteData.agreementTotalPayment.finalPayment,
        TotalPayment: getCOpriceQuoteData.agreementTotalPayment.totalPayments,
        AgreementTotal: getCOpriceQuoteData.agreementTotalPayment?.totalCost ? getCOpriceQuoteData.agreementTotalPayment.totalCost : agreementTotal ? agreementTotal : searchResult[0].totalCost,
        TotalPaymentTerm:
          getCOpriceQuoteData.agreementTotalPayment.totalPayments,
        Discount: getCOpriceQuoteData?.agreementInitialPayment?.discount
      });
      setOtherAmt(getCOpriceQuoteData.agreementInitialPayment.totalFeesAmount);
      setsacAmount(getCOpriceQuoteData?.agreementTotalPayment?.cashPrice ? getCOpriceQuoteData?.agreementTotalPayment?.cashPrice : totalCashPrice ? totalCashPrice : searchResult[0].cashPrice);
    } else if (searchResult == undefined && wholeAgrInfoResponse) {
      //
      setpaymentScheduleValues(getCOpriceQuoteData.paymentSchedule);
      setinitialPaymentAmount({
        ...initialPaymentAmount,
        Club: getCOpriceQuoteData.agreementInitialPayment.clubAmount,
        LDW: getCOpriceQuoteData.agreementInitialPayment.ldw,
        Tax: getCOpriceQuoteData.agreementInitialPayment.totalTax,
        Rate: getCOpriceQuoteData.agreementInitialPayment.initialRate,
        InitialPayment:
          getCOpriceQuoteData.agreementInitialPayment.initialPayment,
      });
      settotalPaymentAmount({
        ...totalPaymentAmount,
        InitialPayment:
          getCOpriceQuoteData.agreementTotalPayment.initialPaymentTotal,
        RegularPayments:
          getCOpriceQuoteData.agreementTotalPayment.regularPaymentsAmount,
        RegularPaymentsTerm:
          getCOpriceQuoteData.agreementTotalPayment.regularPaymentsCount,
        FinalPayment: getCOpriceQuoteData.agreementTotalPayment.finalPayment,
        TotalPayment: getCOpriceQuoteData.agreementTotalPayment.totalPayments,
        AgreementTotal: getCOpriceQuoteData?.agreementTotalPayment?.totalCost ? getCOpriceQuoteData?.agreementTotalPayment?.totalCost : getCOpriceQuoteData.agreementTotal,
        TotalPaymentTerm:
          getCOpriceQuoteData.agreementTotalPayment.totalPayments,
        Discount: getCOpriceQuoteData?.agreementInitialPayment?.discount,
      });
      setsacAmount(getCOpriceQuoteData?.agreementTotalPayment?.cashPrice ? getCOpriceQuoteData?.agreementTotalPayment?.cashPrice : getCOpriceQuoteData.agreementTotalPayment.sacTotal);
    }
    // eslint-disable-next-line sonarjs/no-duplicated-branches
    else if (value != undefined) {
      setpaymentScheduleValues(getCOpriceQuoteData.paymentSchedule);
      setinitialPaymentAmount({
        ...initialPaymentAmount,
        Club: getCOpriceQuoteData.agreementInitialPayment.clubAmount,
        LDW: getCOpriceQuoteData.agreementInitialPayment.ldw,
        Tax: getCOpriceQuoteData.agreementInitialPayment.totalTax,
        Rate: getCOpriceQuoteData.agreementInitialPayment.initialRate,
        InitialPayment:
          getCOpriceQuoteData.agreementInitialPayment.initialPayment,
      });

      settotalPaymentAmount({
        ...totalPaymentAmount,
        InitialPayment:
          getCOpriceQuoteData.agreementTotalPayment.initialPaymentTotal,
        RegularPayments:
          getCOpriceQuoteData.agreementTotalPayment.regularPaymentsAmount,
        RegularPaymentsTerm:
          getCOpriceQuoteData.agreementTotalPayment.regularPaymentsCount,
        FinalPayment: getCOpriceQuoteData.agreementTotalPayment.finalPayment,
        TotalPayment: getCOpriceQuoteData.agreementTotalPayment.totalPayments,
        AgreementTotal: getCOpriceQuoteData?.agreementTotalPayment?.totalCost ? getCOpriceQuoteData?.agreementTotalPayment?.totalCost : getCOpriceQuoteData.agreementTotal,
        TotalPaymentTerm:
          getCOpriceQuoteData.agreementTotalPayment.totalPayments,
        Discount: getCOpriceQuoteData?.agreementInitialPayment?.discount,
      });
      setsacAmount(getCOpriceQuoteData?.agreementTotalPayment?.cashPrice ? getCOpriceQuoteData?.agreementTotalPayment?.cashPrice : getCOpriceQuoteData.agreementTotalPayment.sacTotal);
    }

    if (featureFlagDetails.EnableRewardPromotion == '1' && rewardEntered != '') {
      setRewardAppliedPriceQuoteAmount(getCOpriceQuoteData.agreementInitialPayment?.rewardsAmountUsed ?? '0.00');
    }
  };
  const Addsuffix = (value) => {
    const covertvalue = parseInt(value);
    if (covertvalue < 1000) {
      const FirstCheck = covertvalue % 10;
      const SecondCheck = covertvalue % 100;
      if (FirstCheck == 1 && SecondCheck != 11) {
        return covertvalue + ((language == 'es-MX' || language == 'es-US') ? '' : 'st');
      }
      if (FirstCheck == 2 && SecondCheck != 12) {
        return covertvalue + ((language == 'es-MX' || language == 'es-US') ? '' : 'nd');
      }
      if (FirstCheck == 3 && SecondCheck != 13) {
        return covertvalue + ((language == 'es-MX' || language == 'es-US') ? '' : 'rd');
      }
      return covertvalue + ((language == 'es-MX' || language == 'es-US') ? '' : 'th');
    } else {
      return value;
    }
  };
  const addArrayValue = (SourceArray: any, Keyname: string) => {
    const ArrayWithValues = SourceArray.map((ele: any) => {
      return parseFloat(ele[Keyname]);
    });
    let AdditionValue = 0;
    for (let index = 0; index < ArrayWithValues.length; index++) {
      AdditionValue = AdditionValue + ArrayWithValues[index];
    }
    return AdditionValue.toString();
  };
  function formatMoney(Money: any) {
    console.log('Money', Money);

    if (Money !== undefined && typeof Money === 'string') {
      let MoneyFormat = Money.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      if (MoneyFormat === '0') {
        MoneyFormat = `${MoneyFormat}.00`;
      }
      return MoneyFormat;
    }
  }
  const StorePreviousDropdownValue = () => {
    setsuccessDropdownValues({
      ...successDropdownValues,
      Schedule: scheduleValue,
      Term: termValue,
      Range: rangeValue,
      PromoCode: offerCodeValue,
      OptionalService: optServiceValue,
    });
  };
  const DropdownReset = () => {
    setscheduleValue(successDropdownValues.Schedule);
    settermValue(successDropdownValues.Term);
    setrangeValue(successDropdownValues.Range);
    setoptServiceValue(successDropdownValues.OptionalService);
    setofferCodeValue(successDropdownValues.PromoCode);
    if (successDropdownValues.Schedule == 'WK') {
      setselectedSchedule({
        ...selectedSchedule,
        WeeklySchedule: true,
        BiWeeklySchedule: false,
        MonthlySchedule: false,
        SemiMonthlySchedule: false,
      });
      setrangeactive(false);
    }
    if (successDropdownValues.Schedule == 'BIWK') {
      setselectedSchedule({
        ...selectedSchedule,
        WeeklySchedule: false,
        BiWeeklySchedule: true,
        MonthlySchedule: false,
        SemiMonthlySchedule: false,
      });
      setrangeactive(false);
    }
    if (successDropdownValues.Schedule == 'MON') {
      setselectedSchedule({
        ...selectedSchedule,
        WeeklySchedule: false,
        BiWeeklySchedule: false,
        MonthlySchedule: true,
        SemiMonthlySchedule: false,
      });
      setrangeactive(false);
    } else {
      setselectedSchedule({
        ...selectedSchedule,
        WeeklySchedule: false,
        BiWeeklySchedule: false,
        MonthlySchedule: false,
        SemiMonthlySchedule: true,
      });
      setrangeactive(true);
    }
  };
  // const DropdownResetError = () => {
  //   setofferCodeValue(errbackupVal == null ? '' : errbackupVal);
  // };
  const WeeklyScheduleOnClick = (ScheduleName: string) => {
    if (!editDisableMode && scheduleValue != 'WK') {
      console.log('Weekly Schedule selected');
      const TempGetPriceReq: any = priceQuoteReq;
      TempGetPriceReq.schedule = 'WK';
      setscheduleValue('WK');
      setselectedSchedule({
        ...selectedSchedule,
        WeeklySchedule: true,
        BiWeeklySchedule: false,
        MonthlySchedule: false,
        SemiMonthlySchedule: false,
      });
      setrangeactive(false);
      settermValue(paymentScheduleValues.weeklyTerm);
      StorePreviousDropdownValue();
      Recalculation(TempGetPriceReq);
    }
  };
  const BiWeeklyScheduleOnClick = (ScheduleName: string) => {
    if (!editDisableMode && scheduleValue != 'BIWK') {
      console.log('BiWeekly Schedule selected');
      const TempGetPriceReq: any = priceQuoteReq;
      TempGetPriceReq.schedule = 'BIWK';
      setscheduleValue('BIWK');
      setselectedSchedule({
        ...selectedSchedule,
        WeeklySchedule: false,
        BiWeeklySchedule: true,
        MonthlySchedule: false,
        SemiMonthlySchedule: false,
      });
      setrangeactive(false);
      settermValue(paymentScheduleValues.biweeklyTerm);
      StorePreviousDropdownValue();
      Recalculation(TempGetPriceReq);
    }
  };
  const MonthlyScheduleOnClick = (ScheduleName: string) => {
    if (!editDisableMode && scheduleValue != 'MON') {
      console.log('Monthly Schedule selected');
      const TempGetPriceReq: any = priceQuoteReq;
      TempGetPriceReq.schedule = 'MON';
      setscheduleValue('MON');
      setselectedSchedule({
        ...selectedSchedule,
        WeeklySchedule: false,
        BiWeeklySchedule: false,
        MonthlySchedule: true,
        SemiMonthlySchedule: false,
      });
      setrangeactive(false);
      settermValue(paymentScheduleValues.monthlyTerm);
      StorePreviousDropdownValue();
      Recalculation(TempGetPriceReq);
    }
  };
  const SemiMonthlyOnClick = (ScheduleName: string) => {
    if (!editDisableMode && scheduleValue != 'SEMI1-15') {
      console.log('SemiMonthly Schedule selected');
      const TempGetPriceReq: any = priceQuoteReq;
      TempGetPriceReq.schedule = 'SEMI1-15';
      setscheduleValue('SEMI1-15');
      setrangeValue('SEMI1-15');
      setselectedSchedule({
        ...selectedSchedule,
        WeeklySchedule: false,
        BiWeeklySchedule: false,
        MonthlySchedule: false,
        SemiMonthlySchedule: true,
      });
      setrangeactive(true);
      settermValue(paymentScheduleValues.semimonthlyTerm);
      StorePreviousDropdownValue();
      Recalculation(TempGetPriceReq);
    }
  };
  const AgreementSourceOnchange = (value: any) => {
    console.log('AgrSourceOnchange Triggered');
    setagreementSourceValue(value);
  };
  const ScheduleOnchange = (value: any) => {
    console.log('ScheduleOnchange Triggered');
    const ScheduleType = value;
    const TempGetPriceReq: any = priceQuoteReq;
    setscheduleValue(ScheduleType);
    StorePreviousDropdownValue();
    if (ScheduleType == 'WK') {
      setselectedSchedule({
        ...selectedSchedule,
        WeeklySchedule: true,
        BiWeeklySchedule: false,
        MonthlySchedule: false,
        SemiMonthlySchedule: false,
      });
      setrangeactive(false);
      settermValue(paymentScheduleValues.weeklyTerm);
    }
    if (ScheduleType == 'BIWK') {
      setselectedSchedule({
        ...selectedSchedule,
        WeeklySchedule: false,
        BiWeeklySchedule: true,
        MonthlySchedule: false,
        SemiMonthlySchedule: false,
      });
      setrangeactive(false);
      settermValue(paymentScheduleValues.biweeklyTerm);
    }
    if (ScheduleType == 'MON') {
      setselectedSchedule({
        ...selectedSchedule,
        WeeklySchedule: false,
        BiWeeklySchedule: false,
        MonthlySchedule: true,
        SemiMonthlySchedule: false,
      });
      setrangeactive(false);
      settermValue(paymentScheduleValues.monthlyTerm);
    }
    if (ScheduleType == 'SEMI1-15') {
      setselectedSchedule({
        ...selectedSchedule,
        WeeklySchedule: false,
        BiWeeklySchedule: false,
        MonthlySchedule: false,
        SemiMonthlySchedule: true,
      });
      setrangeactive(true);
      setrangeValue('SEMI1-15');
      settermValue(paymentScheduleValues.semimonthlyTerm);
    }
    TempGetPriceReq.schedule = ScheduleType;
    Recalculation(TempGetPriceReq);
  };
  const RangeOnchange = (value: any) => {
    console.log('RangeOnchange Triggered');
    const TempGetPriceReq: any = priceQuoteReq;
    TempGetPriceReq.schedule = value;
    setrangeValue(value);
    setscheduleValue(value);
    StorePreviousDropdownValue();
    Recalculation(TempGetPriceReq);
  };
  const OfferCodeOnchange = (value: any) => {
    console.log('OfferCodeOnchange Triggered');
    const TempGetPriceReq: any = priceQuoteReq;
    value != ''
      ? (TempGetPriceReq.promoCode = value == 'referral' ? null : value)
      : (TempGetPriceReq.promoCode = null);
    setofferCodeValue(value);
    if (value == 'referral' && customerReferralCode && isCOReferralEnabled) {
      TempGetPriceReq.promoCode = customerReferralCode;
      setRewardEntered(customerReferralCode);
      setRewardErrorMessage({ ...rewardErrorMessage, isInvalidMsg: '', isSuccessMsg: '' })
    }
    else {
      setRewardEntered('');
      setRewardErrorMessage({ ...rewardErrorMessage, isInvalidMsg: '', isSuccessMsg: '' })
      StorePreviousDropdownValue();
    }
    Recalculation(TempGetPriceReq);
  };
  const OptServiceOnchange = (value: any) => {
    const TempGetPriceReq: any = priceQuoteReq;
    StorePreviousDropdownValue();
    if (
      !CLUB_STATUS_ACTIVE_PENDING.includes(ClubStatus) &&
      IsLdwTiedWithClub === true &&
      LDWstatus !== 'A' &&
      value === 'LDWC'
    ) {
      console.log('setAddingBpclubOpen');
      setAddingBpclubOpen(true);
    } else if (
      CLUB_STATUS_ACTIVE_PENDING.includes(ClubStatus) &&
      IsLdwTiedWithClub === true &&
      value === 'NONE'
      // ClubOriginStore == window.sessionStorage.getItem('storeNumber')
    ) {
      console.log('setDecliningLdwOpen');
      setDecliningLdwOpen(true);
    } else {
      if (value == 'LDWC') {
        TempGetPriceReq.isLDWApplied = true;
        TempGetPriceReq.isClubApplied = true;
      } else if (value == 'NONE') {
        TempGetPriceReq.isLDWApplied = false;
        TempGetPriceReq.isClubApplied = false;
      } else if (value == 'LDW') {
        TempGetPriceReq.isLDWApplied = true;
        TempGetPriceReq.isClubApplied = false;
      }

      Recalculation(TempGetPriceReq);
      setoptServiceValue(value);
    }
  };
  const SalesPersonOnchange = (value: any) => {
    setsalesPersonValue(value);
    if (value != '') {
      setnextBtnDisabled(false);
    } else {
      setnextBtnDisabled(true);
    }
  };

  const PreviousBtnClick = () => {
    if (isLocalSourcingFlow) {
      history.push({
        pathname: `/dashboard/homepage`,
      });
      const navEvent = new PopStateEvent('popstate');
      window.dispatchEvent(navEvent);
      return;
    }
    if (AgreementId && salesLeadId) {
      history.push({
        pathname: `/agreement/customerorder/itemsearch/${customerId}/${AgreementId}?coCustomerId=N&salesLeadId=${salesLeadId}`,
      });
      // communicate to Routes that URL has changed//
      const navEvent = new PopStateEvent('popstate');
      window.dispatchEvent(navEvent);
    } else if (AgreementId == undefined && salesLeadId == undefined) {
      history.push({
        pathname: `/agreement/customerorder/itemsearch/${customerId}?coCustomerId=N`,
      });
      // communicate to Routes that URL has changed//
      const navEvent = new PopStateEvent('popstate');
      window.dispatchEvent(navEvent);
    } else if (!AgreementId) {
      history.push({
        pathname: `/agreement/customerorder/itemsearch/${customerId}`,
      });
      // communicate to Routes that URL has changed//
      const navEvent = new PopStateEvent('popstate');
      window.dispatchEvent(navEvent);
    } else if (AgreementId) {
      history.push({
        pathname: `/agreement/customerorder/itemsearch/${customerId}/${AgreementId}?coCustomerId=N`,
      });
      // communicate to Routes that URL has changed//
      const navEvent = new PopStateEvent('popstate');
      window.dispatchEvent(navEvent);
    }
  };
  const DropdownResetError = () => {
    setofferCodeValue(errbackupVal == null ? '' : errbackupVal);
    setscheduleValue('WK');
    setselectedSchedule({
      ...selectedSchedule,
      WeeklySchedule: true,
      BiWeeklySchedule: false,
      MonthlySchedule: false,
      SemiMonthlySchedule: false,
    });
  };
  const Recalculation = async (RequestObj: any) => {
    console.log('RequestObj', RequestObj);
    try {

      if(featureFlagDetails?.EnableCustomerTierReward == '1' && customerTierDetails?.memberStatus == 'Active'){
        RequestObj.customerTier = customerTierDetails?.memberTiers?.loyaltyMemberTier
      }

      setprocessFeeDisable(true);
      setpageLoading(true);
      seteditDisableMode(true);
      seterrbackupVal(RequestObj?.promoCode);
      const getCOpriceQuoteResponse = await getCOpriceQuote(RequestObj);
      setpageLoading(false);
      seteditDisableMode(false);
      if (getCOpriceQuoteResponse.status == 200) {
        if (getCOpriceQuoteResponse?.data?.promoEngineResponse?.promotionCode || getCOpriceQuoteResponse?.data?.promoEngineResponse?.promotionNumber) {
          setTierPromotionsValue(getCOpriceQuoteResponse?.data?.promoEngineResponse)
        }
        else {
          setTierPromotionsValue('')
        }
        setprocessFeeDisable(false);
        setpriceQuoteRes(getCOpriceQuoteResponse.data);
        setpriceQuoteReq(RequestObj);
        const getCOpriceQuoteData = getCOpriceQuoteResponse.data;
        GetPriceQuoteValueBind(getCOpriceQuoteData);
        if (offerCodeValue == 'referral' && RequestObj.promoCode != null && featureFlagDetails?.EnableRewardPromotion == '1')
          rewardPromoErrorMessageHandling(getCOpriceQuoteResponse);

      } else if (getCOpriceQuoteResponse.status == 400) {
        setprocessFeeDisable(false);

        if (offerCodeValue == 'referral' && RequestObj.promoCode != null && featureFlagDetails?.EnableRewardPromotion == '1') {
          rewardPromoErrorMessageHandling(getCOpriceQuoteResponse);
          setCustomerReferralCode(undefined);
          setRewardPromotion(undefined);
          setofferCodeValue('');
          setRewardEntered('');
          RequestObj= {
            ...RequestObj,
            promoCode: ''
          };
          Recalculation(RequestObj);
        }
        else {
          const ErrorMessage = getCOpriceQuoteResponse.data.errors[0].error;
          setapiFailFirstMessage(ErrorMessage);
          setapiFailSecondMessage('Please update and try again');
          setapiFailPopupOpen(true);
          DropdownResetError();
        }

      } else {
        if (offerCodeValue == 'referral' && RequestObj.promoCode != null && featureFlagDetails?.EnableRewardPromotion == '1')
          rewardPromoErrorMessageHandling(getCOpriceQuoteResponse)
        else {
          DropdownReset();
          setprocessFeeDisable(false);
          setpageLoading(false);
          setsomethingWentWrongOpen(true);
        }
      }
    } catch {
      console.log('Im in Recalculation catch');
      setpageLoading(false);
      seteditDisableMode(false);
      setsomethingWentWrongOpen(true);
    }
  };


  const rewardPromoErrorMessageHandling = (response) => {
    if (response.status == 200) {
      setRewardErrorMessage({ ...rewardErrorMessage, isSuccessMsg: 'The promo was applied successfully' });
    } else if (response.status == 400) {
      if (response.data.errors[0].error?.includes('Invalid'))
        setRewardErrorMessage({ ...rewardErrorMessage, isInvalidMsg: 'The referral code you entered is invalid or does not exist. Please try again', isSuccessMsg: '' });
      else if (response.data.errors[0].error?.includes('Not Eligible'))
        setRewardErrorMessage({ ...rewardErrorMessage, isInvalidMsg: 'Customer Not Eligible for Reward Program.', isSuccessMsg: '' });
    }
    else
      setRewardErrorMessage({ ...rewardErrorMessage, isInvalidMsg: 'An error occurred while processing the promo code. Please try again later.', isSuccessMsg: '' });
  }

  const rewardOnBlur = (val) => {
    const TempGetPriceReq: any = priceQuoteReq;
    let value = val.replace(/[ ,]/g, "")
    if (value != '') {
      setRewardEntered(value);
      TempGetPriceReq.promoCode = value;
    } else {
      setRewardEntered('');
      TempGetPriceReq.promoCode = null;
    }

    Recalculation(TempGetPriceReq);
  }
  // const NextBtnClick = () => {
  //   console.log('next btn clicked');
  //   if (
  //     PopupCompleteStatus.AgreementCreated === true &&
  //     PopupCompleteStatus.ConfirmDueDateComplete === true
  //   ) {
  //     setcustomerSignatureEnabled(true);
  //   } else if (
  //     PopupCompleteStatus.AgreementCreated === false &&
  //     PopupCompleteStatus.ConfirmDueDateComplete === false
  //   ) {
  //     setsecondFactorEnabled(true);
  //   } else if (PopupCompleteStatus.CustomerSignComplete === true) {
  //     setpaymentPopupOpen(true);
  //   } else if (PopupCompleteStatus.InitialPaymentComplete === true) {
  //     history.push({
  //       pathname: `/agreement/customerorder/postatus/${customerId}/${AgreementId}`,
  //     });
  //     const navEvent = new PopStateEvent('popstate');
  //     window.dispatchEvent(navEvent);
  //   }
  // };
  // const NextBtnClick = () => {
  //   console.log('next btn clicked', PopupCompleteStatus);
  //   if (PopupCompleteStatus.InitialPaymentComplete === true) {
  //     history.push(
  //       `/agreement/customerorder/postatus/${customerId}/${
  //         AgreementId == undefined ? agreementId : AgreementId
  //       }`
  //     );
  //     const navEvent = new PopStateEvent('popstate');
  //     window.dispatchEvent(navEvent);
  //   } else if (PopupCompleteStatus.CustomerSignComplete === true) {
  //     setpaymentPopupOpen(true);
  //   } else if (
  //     PopupCompleteStatus.AgreementCreated === false &&
  //     PopupCompleteStatus.ConfirmDueDateComplete === false
  //   ) {
  //     setsecondFactorEnabled(true);
  //   } else if (
  //     PopupCompleteStatus.AgreementCreated === true &&
  //     PopupCompleteStatus.ConfirmDueDateComplete === true
  //   ) {
  //     setcustomerSignatureEnabled(true);
  //   }
  // };


  // const NextBtnClick = () => {
  //   // setTbIframePopup(true)
  //   tbTwoFactorCompletedFn()
  // }
  const NextBtnClick = () => {
    debugger
    if ((isTireBuyerFlow == '1' || getAgreementInfoRes?.installerInformation) && featureFlagDetails?.TireBuyer == '1') {
      tbCustomerOrderNextClick()
      return
    }
    else if (
      PopupCompleteStatus.PrelimpaymentPaymentComplete === true ||
      PopupCompleteStatus.AgreementStatus == 'Preliminary Refunded'
    ) {
      history.push(
        `/agreement/customerorder/postatus/${customerId}/${AgreementId == undefined ? agreementId : AgreementId
        }`
      );
      const navEvent = new PopStateEvent('popstate');
      window.dispatchEvent(navEvent);
    } else if (PopupCompleteStatus.InitialPaymentComplete === true) {
      history.push(
        `/agreement/customerorder/delivery/${customerId}/${AgreementId == undefined ? agreementId : AgreementId
        }`
      );
    } else if (
      PopupCompleteStatus.PrelimpaymentPaymentComplete === false &&
      PopupCompleteStatus.CustomerSignComplete === true
    ) {
      setpaymentPopupOpen(true);
    } else if (
      PopupCompleteStatus.CustomerSignComplete === false &&
      PopupCompleteStatus.PrelimpaymentPaymentComplete === false &&
      PopupCompleteStatus.AgreementCreated === false
    ) {
      proceedToNormalFlowSecondFactor();
    } else if (
      PopupCompleteStatus.CustomerSignComplete === false &&
      PopupCompleteStatus.AgreementCreated === true
    ) {
      setcustomerSignatureEnabled(true);
    }
  };
  const proceedToNormalFlowSecondFactor = () => {
    const canProceed = evaluateDEEnforcementAndGate();
    if (!canProceed) {
      return;
    }
    setsecondFactorEnabled(true);
  };
  const tbCustomerOrderNextClick = async () => {
    debugger
    if (getAgreementInfoRes?.agreementWorkflow?.isAgreementSigned != '1' && (getAgreementInfoRes?.agreementWorkflow?.isPreliminaryPaymentPaid == '1' || getAgreementInfoRes?.agreementWorkflow?.isPreliminaryPaymentPaid == '0')) {
      setcustomerSignatureEnabled(true);
    }
    else if (getAgreementInfoRes?.agreementWorkflow?.isAgreementSigned == '1' && getAgreementInfoRes?.agreementWorkflow?.isPreliminaryPaymentPaid != '1') {
      setpaymentPopupOpen(true)

    }
    else if (getAgreementInfoRes?.agreementWorkflow?.isAgreementSigned == '1' && getAgreementInfoRes?.agreementWorkflow?.isPreliminaryPaymentPaid == '1') {
      history.push(
        `/agreement/customerorder/postatus/${customerId}/${AgreementId == undefined ? agreementId : AgreementId
        }`
      );
      const navEvent = new PopStateEvent('popstate');
      window.dispatchEvent(navEvent);
    }
    else if (normalFlowCustomerSign) {
      setpaymentPopupOpen(true)

    }
    else if (
      tbCustomerSignCancel
    ) {
      setcustomerSignatureEnabled(true)
    }
    else {
      settbSecondFactor(true)

    }

  }
  const PreliminaryPaymentCloseClick = () => {
    console.log('Close click triggered');
    setpaymentPopupOpen(false);
  };
  const PreliminaryPaymentNoBtnclick = () => {
    console.log('No click triggered');
    setpaymentPopupOpen(false);
  };
  const PreliminaryPaymentYesclick = () => {
    console.log('yes click triggered');
    setpaymentPopupOpen(false);
    const agrId = AgreementId == undefined ? agreementId : AgreementId;
    const basePath = `/payment1/customerorder/preliminary/${customerId}/${agrId}`;
    // Local Sourcing: Forward spendLimitId to prelim payment if present in current URL
    const currentSpendLimitId = new URLSearchParams(window.location.search).get('spendLimitId');
    const path = currentSpendLimitId
      ? `${basePath}?spendLimitId=${currentSpendLimitId}`
      : basePath;
    history.push(path);
  };
  const TwoFactorCancelFn = () => {
    setsecondFactorEnabled(false);
  };
  function getActivePhoneNumber(phoneNumbers: any) {
    for (const phoneNumber of phoneNumbers) {
      switch (phoneNumber.phoneType) {
        case 'CELL':
          return phoneNumber.PhoneNumber;
        case 'HOME':
          return phoneNumber.PhoneNumber;
        case 'REF':
          return phoneNumber.PhoneNumber;
        case 'WORK':
          return phoneNumber.PhoneNumber;
        default:
          return phoneNumber.PhoneNumber

      }
    }
    return undefined;
  }
  const TwoFactorCompleteFn = async (value: any) => {
    if (value) {
      console.log('offerCodeValue', offerCodeValue, sacAmount, searchResult[0].cashPrice);
      setsecondFactorEnabled(false);
      setcreateAgrProcessingPopup(true);
      const createAgreementReqTemp: any = createAgreementReq;
      createAgreementReqTemp.sacTotal = offerCodeValue
        ? searchResult.reduce((sum: number, obj: any) => sum + parseFloat(obj.cashPrice || '0'), 0).toFixed(2)
        : sacAmount;
      createAgreementReqTemp.schedule = scheduleValue;
      createAgreementReqTemp.agreementSource = agreementSourceValue;
      createAgreementReqTemp.salesPersonId = salesPersonValue;
      createAgreementReqTemp.items = consolidateItemsByRmsNumber(searchResult.map((obj: any, index: number) => {
        // searchResult[0] may have been mutated to aggregated pricing after price quote response.
        // When duplicates exist (same rmsItemNumber), use per-unit values from a non-mutated entry.
        const hasDuplicateRms = isLocalSourcingFlow && searchResult.length > 1
          && searchResult.filter((s: any) => s.rmsItemNumber === obj.rmsItemNumber).length > 1;
        const perUnitSource = (index === 0 && hasDuplicateRms)
          ? searchResult.find((s: any, i: number) => i > 0 && s.rmsItemNumber === obj.rmsItemNumber) || obj
          : obj;

        return {
          rmsItemNumber: obj.rmsItemNumber,
          warehouseId: obj.wareHouseId,
          packageId: null,
          rmsItemQuantity: obj.quantity ? String(obj.quantity) : '1',
          weeklyRate: perUnitSource.weeklyRate,
          weeklyTerm: perUnitSource.weeklyTerm,
          cashPrice: perUnitSource.cashPrice,
          unitCost:
            obj.availability?.unitCost
              ? String(obj?.availability?.unitCost)
              : null,
          offerId:
            obj?.availability?.offerId == ''
              ? null
              : obj?.availability?.offerId,
        };
      }));

      if (isCOReferralEnabled && offerCodeValue == 'referral') {
        createAgreementReqTemp.promoCode =
          rewardEntered != '' ? rewardEntered : null;
        createAgreementReqTemp.referralCode = rewardEntered
      }
      else
        createAgreementReqTemp.promoCode =
          offerCodeValue != '' ? offerCodeValue : null;

      createAgreementReqTemp.isLDWApplied =
        optServiceValue == 'LDW' || optServiceValue == 'LDWC'
          ? 'true'
          : 'false';
      createAgreementReqTemp.isClubApplied =
        optServiceValue == 'LDWC' || optServiceValue == 'BPC'
          ? 'true'
          : 'false';
      createAgreementReqTemp.agreementRate =
        priceQuoteRes.paymentSchedule.weeklyRate;
      createAgreementReqTemp.agreementTerm =
        priceQuoteRes.paymentSchedule.weeklyTerm;

      if(featureFlagDetails?.EnableCustomerTierReward == '1' && customerTierDetails?.memberStatus == 'Active'){
        createAgreementReqTemp.customerTier = customerTierDetails?.memberTiers?.loyaltyMemberTier
      }

      // Local Sourcing: Enrich create agreement payload with LS fields
      applyLocalSourcingPayload(createAgreementReqTemp);

      const CreateAgreementResponse = await coCreateAgreement(
        createAgreementReqTemp
      );
      if (CreateAgreementResponse.status == 200) {
        // Handle duplicate agreement response from Local Sourcing wrapper
        if (CreateAgreementResponse.data?.isDuplicate) {
          setcreateAgrProcessingPopup(false);
          setapiFailFirstMessage(
            CreateAgreementResponse.data.message ||
              t('Agreement already exists for this purchase order')
          );
          setapiFailSecondMessage(
            `${t('Agreement')} #${CreateAgreementResponse.data.agreementNumber || ''}`
          );
          setapiFailPopupOpen(true);
          return;
        }
        const submittedTextBoxPromo = customerPromotions?.promotions?.find(
          (promotion: any) =>
            promotion.isTextBoxPromotion === 'Y' &&
            String(promotion.promotionNumber) ===
              String(createAgreementReqTemp.promoCode)
        );
        if (submittedTextBoxPromo) {
          window?.dataLayer?.push({
            event: 'Applied text box promo',
            customerId,
            storeNo: window.sessionStorage.getItem('storeNumber'),
            agreementNo: CreateAgreementResponse.data?.agreementId?.toString(),
            employeeId: containerData?.GetEmployeeId?.() || '',
            role: currentRole || containerData?.GetRole?.() || '',
            currentScreen: 'Customer Order-Agreement Details',
            previousScreen: 'Customer Order-Item Search',
            promoNumber: submittedTextBoxPromo.promotionNumber,
            source: 'RACPAD'
          });
        }
        //setcustomerSignatureEnabled(true);
        setprocessFeeDisable(true);
        setPopupCompleteStatus({
          ...PopupCompleteStatus,
          CustomerSignComplete: false,
          AgreementCreated: true,
        });
        setAgreementId(CreateAgreementResponse.data.agreementId.toString());
        setcreateAgrProcessingPopup(false);
        if (deOverrideApproverDetailsRef.current) {
          recordDEOverrideAudit({
            agreementId: CreateAgreementResponse.data.agreementId,
            approverDetails: deOverrideApproverDetailsRef.current,
          }).catch((e) => console.error('Error recording DE override audit', e));
          deOverrideApproverDetailsRef.current = null;
          setDeOverrideApproverDetails(null);
        }
        const AgreementCustomers =
          CreateAgreementResponse.data.customerInformation;
        const Customerdata = AgreementCustomers.filter(
          (obj) => obj.priority == 1
        );
        const CustomerName =
          Customerdata[0].firstName + ' ' + Customerdata[0].lastName;
        if (AgreementCustomers.length === 1) {
          const AGreementDocObj: any = GenerateDocReq;
          const CustomerObj = [
            {
              customerId: Customerdata[0].customerId.toString(),
              customerName: CustomerName,
              phoneNumber: Customerdata[0]?.phoneNumbers ? getActivePhoneNumber(Customerdata[0]?.phoneNumbers) ? getActivePhoneNumber(Customerdata[0]?.phoneNumbers) : Customerdata[0]?.phoneNumber : Customerdata[0]?.phoneNumber,
              emailId: Customerdata[0].emailAddress,
              priority: 1,
            },
          ];
          console.log('PayloadForm');
          AGreementDocObj.signers = CustomerObj;
          setGenerateDocReq(AGreementDocObj);
          setAgrCustomerObj(CustomerObj);
          setcustomerSignatureEnabled(true);
        } else {
          const AGreementDocObj: any = GenerateDocReq;
          const CoCustomer = AgreementCustomers.filter(
            (obj) => obj.priority == 2
          );
          const CoCustomerName =
            CoCustomer[0].firstName + ' ' + CoCustomer[0].lastName;
          const CustomerObj = [
            {
              customerId: Customerdata[0].customerId.toString(),
              customerName: CustomerName,
              phoneNumber: Customerdata[0]?.phoneNumbers ? getActivePhoneNumber(Customerdata[0]?.phoneNumbers) ? getActivePhoneNumber(Customerdata[0]?.phoneNumbers) : Customerdata[0]?.phoneNumber : Customerdata[0]?.phoneNumber,
              emailId: Customerdata[0].emailAddress,
              priority: 1,
            },
            {
              customerId: CoCustomer[0].customerId.toString(),
              customerName: CoCustomerName,
              phoneNumber: CoCustomer[0]?.phoneNumbers ? getActivePhoneNumber(CoCustomer[0]?.phoneNumbers) ? getActivePhoneNumber(CoCustomer[0]?.phoneNumbers) : CoCustomer[0]?.phoneNumber : CoCustomer[0]?.phoneNumber,
              emailId: CoCustomer[0].emailAddress,
              priority: 2,
            },
          ];
          AGreementDocObj.signers = CustomerObj;
          setGenerateDocReq(AGreementDocObj);
          setAgrCustomerObj(CustomerObj);
          setcustomerSignatureEnabled(true);
        }
        const AgreementDocReq: any = GenerateDocReq;
        AgreementDocReq.identifier = parseInt(
          CreateAgreementResponse.data.agreementId
        );
        AgreementDocReq.identifierType = 'AGR';
        AgreementDocReq.signatureType = 1;
        AgreementDocReq.isRemote = false;
        AgreementDocReq.manualSignatureReasonId = null;
        if (AgreementCustomers.length === 1) {
          const CustomerObj = [
            {
              customerId: Customerdata[0].customerId.toString(),
              customerName: CustomerName,
              phoneNumber:
                Customerdata[0].phoneNumber !== null
                  ? Customerdata[0].phoneNumber
                  : '1111111111',
              emailId:
                Customerdata[0].emailAddress !== null
                  ? Customerdata[0].emailAddress
                  : 'test@example.com',
              priority: 1,
            },
          ];
          AgreementDocReq.signers = CustomerObj;
        } else {
          const CoCustomer = AgreementCustomers.filter(
            (obj) => obj.priority == 2
          );
          const CoCustomerName =
            CoCustomer[0].firstName + ' ' + CoCustomer[0].lastName;

          const CustomerObj = [
            {
              customerId: Customerdata[0].customerId.toString(),
              customerName: CustomerName,
              phoneNumber:
                Customerdata[0].phoneNumber !== null
                  ? Customerdata[0].phoneNumber
                  : '1111111111',
              emailId:
                Customerdata[0].emailAddress !== null
                  ? Customerdata[0].emailAddress
                  : 'test@example.com',
              priority: 1,
            },
            {
              customerId: CoCustomer[0].customerId.toString(),
              customerName: CoCustomerName,
              phoneNumber:
                CoCustomer[0].phoneNumber !== null
                  ? CoCustomer[0].phoneNumber
                  : '1111111111',
              emailId:
                CoCustomer[0].emailAddress !== null
                  ? CoCustomer[0].emailAddress
                  : 'test@example.com',
              priority: 2,
            },
          ];
          AgreementDocReq.signers = CustomerObj;
        }
        setpreviousBtnDisabled(true);
        const GenerateAgreementDocRes = await GenerateAgreementDoc(
          AgreementDocReq
        );
        console.log(
          'First Generate Agreement Call response',
          GenerateAgreementDocRes
        );
        setpreviousBtnDisabled(false);
        setdocumentGenerateCompleted(true);
        seteditDisableMode(true);
      } else if (CreateAgreementResponse.status == 400) {
        setprocessFeeDisable(false);
        setcreateAgrProcessingPopup(false);
        const ErrorMessage = CreateAgreementResponse.data.errors[0].error;
        setapiFailFirstMessage(ErrorMessage);
        setapiFailSecondMessage(t('Please try again'));
        setapiFailPopupOpen(true);
      } else {
        setprocessFeeDisable(false);
        setcreateAgrProcessingPopup(false);
        setsomethingWentWrongOpen(true);
      }
    }
  };
  const customerSignatureCompletedFn = () => {
    setpaymentPopupOpen(true);
    setnormalFlowCustomerSign(true)
    setcustomerSignatureEnabled(false);
    setPopupCompleteStatus({
      ...PopupCompleteStatus,
      CustomerSignComplete: true,
    });
  };
  const customerSignatureCanceledFn = () => {
    setcustomerSignatureEnabled(false);
    settbCustomerSignCancel(true)
  };
  // eslint-disable-next-line sonarjs/no-identical-functions
  const emailcompletedFn = () => {
    setpaymentPopupOpen(true);
    setcustomerSignatureEnabled(false);
    setPopupCompleteStatus({
      ...PopupCompleteStatus,
      CustomerSignComplete: true,
    });
  };
  const CreateAgreementProcessingPopup = () => {
    return (
      <div
        id="initialpayment"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        aria-hidden="true"
      >
        <Grid className={classes.textCenter}>
          <Typography className={classes.formLabel}>{t("Please wait...")}</Typography>
          <Typography className={classes.formLabel}>
            {t("We are creating the agreement for you!")}
          </Typography>
          <CircularProgress style={{ marginTop: '30px' }} size={25} />
        </Grid>
      </div>
    );
  };
  const ApiFailPopup = () => {
    return (
      <div
        id="initialpayment"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        aria-hidden="true"
      >
        <Grid className={classes.textCenter}>
          <Typography className={classes.formLabel}>
            {t(apiFailFirstMessage)}
          </Typography>
          <Typography className={classes.formLabel}>
            {' '}
            {t(apiFailSecondMessage)}
          </Typography>
        </Grid>
        <Grid
          item
          md={12}
          className={`${classes.mt3} ${classes.pb4} ${classes.textCenter}`}
        >
          <RACButton
            className={classes.mx1}
            variant="contained"
            color="primary"
            onClick={() => {
              setapiFailPopupOpen(false);
              if (isLocalSourcingFlow) {
                history.push('/dashboard/homepage');
              }
            }}
          >
            {t("Ok")}
          </RACButton>
        </Grid>
      </div>
    );
  };
  const SomethingWentWrongPopup = () => {
    return (
      <div
        id="initialpayment"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        aria-hidden="true"
      >
        <Grid className={classes.textCenter}>
          <Alerticon></Alerticon>

          <Typography className={classes.formLabel}>
            {t("Something went wrong!")}
          </Typography>
        </Grid>
        <Grid
          item
          md={12}
          className={`${classes.mt3} ${classes.pb4} ${classes.textCenter}`}
        >
          <RACButton
            className={classes.mx1}
            variant="contained"
            color="primary"
            onClick={() => {
              setsomethingWentWrongOpen(false);
              if (isLocalSourcingFlow) {
                history.push('/dashboard/homepage');
              }
            }}
          >
            {t("Ok")}
          </RACButton>
        </Grid>
      </div>
    );
  };
  const PreliminaryPaymentPopup = () => {
    return (
      <div
        id="initialpayment"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        aria-hidden="true"
      >
        <Grid className={classes.textCenter}>
          <Typography className={classes.mb4}>
            {t("Do you want to take preliminary payment?")}
          </Typography>
        </Grid>
        {/* <Typography style={{ textAlign: 'center', paddingBottom: '14px' }}>
          Note: Please proceed preliminary payment in SIMS
        </Typography> */}
        <Grid className={`${classes.pb4} ${classes.textCenter}`}>
          <RACButton
            variant="outlined"
            color="primary"
            className={classes.mx1}
            onClick={() => PreliminaryPaymentNoBtnclick()}
          >
            {t("No")}
          </RACButton>
          <RACButton
            variant="contained"
            color="primary"
            className={classes.mx1}
            onClick={() => PreliminaryPaymentYesclick()}
          >
            {t("Yes")}
          </RACButton>
        </Grid>
      </div>
    );
  };
  const OtherAmountOnclick = () => {
    setSecondFactorOpen(true);
  };
  const OtherAmtOnblurClick = (e: any) => {
    try {
      const InputTxt = e.target.value;
      let InputTxtArr = InputTxt.split('');
      if (InputTxtArr.includes(',') === true) {
        InputTxtArr = InputTxtArr.filter((element: any) => element != ',');
        let TempString = '';
        for (let i = 0; i <= InputTxtArr.length - 1; i++) {
          TempString = TempString + InputTxtArr[i];
        }
        const FloatInputTxt = parseFloat(TempString);
        const ResultInputTxt = FloatInputTxt.toFixed(2);
        setOtherAmt(ResultInputTxt);
      } else if (InputTxt === '.' || InputTxt === '') {
        setOtherAmt('0.00');
      } else {
        const FloatInputTxt = parseFloat(InputTxt);
        const ResultInputTxt = FloatInputTxt.toFixed(2);
        setOtherAmt(ResultInputTxt);
      }
    } catch {
      throw Error;
    }
  };
  const ProcessingFeeOnBlurClick = (e: any) => {
    try {
      const InputTxt = e.target.value;
      let InputTxtArr = InputTxt.split('');
      if (InputTxtArr.includes(',') === true) {
        InputTxtArr = InputTxtArr.filter((element: any) => element !== ',');
        let TempString = '';
        for (let i = 0; i <= InputTxtArr.length - 1; i++) {
          TempString = TempString + InputTxtArr[i];
        }
        const FloatInputTxt = parseFloat(TempString);
        const ResultInputTxt = FloatInputTxt.toFixed(2);
        setOtherAmt(ResultInputTxt);
      } else if (InputTxt === '.' || InputTxt === '') {
        // setIntPayment({ ...IntPayment, OtherAmt: '0.00' });
        setOtherAmt('0.00');
      } else {
        const FloatInputTxt = parseFloat(InputTxt);
        const ResultInputTxt = FloatInputTxt.toFixed(2);
        setOtherAmt(ResultInputTxt);
      }
    } catch {
      throw Error;
    }
  };
  const ProcessingFeeOnClick = (e: any) => {
    try {
      const InputTxt = e.target;
      InputTxt.select();
    } catch {
      throw Error;
    }
  };
  const ProcessingFeeOnchange = (value: any) => {
    try {
      const TempTxt = parseFloat(value);
      if (TempTxt <= 999.0) {
        setOtherAmt(value);
      }
      if (value == undefined || value === '') {
        setOtherAmt('');
      }
    } catch {
      throw Error;
    }
  };
  const OverRideAmoutClick = () => {
    try {
      // const InputProcessingFeeAmt = parseFloat(processingFee);
      // const ProcessingFeeScale = parseFloat(ProcessingFeeLimit);
      const Recalculatereqobj: any = RecalculateReq;
      if (Number(processingFee) >= Number(OtherAmt)) {
        // const TempReq: any = FeeArrWOProFee;
        setProcessingFeeErrorLbl(false);
        setProcessingFeePopupOpen(false);
        const Obj = {
          feeType: 'PROC',
          feeAmount: processingFee,
        };
        // if (TempReq.filter((e) => e.feeType === 'PROC').length > 0) {
        //   const indexOfDuplicate = TempReq.findIndex(
        //     (arr) => arr.feeType === Obj.feeType
        //   );
        //   TempReq[indexOfDuplicate] = Obj;
        // } else {
        //   TempReq.push(Obj);
        // }
        // console.log('Regenerated fee arr', TempReq);
        //props.OtherAmtChanged(TempReq);
        Recalculatereqobj.processingFee = processingFee;
        //props.RecalculateClicked(Recalculatereqobj);
        setRecalculateReq(Recalculatereqobj);
      } else {
        setProcessingFeeErrorLbl(true);
      }
    } catch {
      throw Error;
    }
  };
  const ProcessingFeePopup = () => {
    return (
      <div
        id="ProcessingFee"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        aria-hidden="true"
      >
        <Grid container className={`${classes.mb2} ${classes.mt2}`}>
          <Grid item md={6} className={classes.floatLeft}>
            <Typography
              variant="subtitle1"
              className={paymentCostClassName.cardLabel}
            >
              {t("Processing Fee Amount")}
            </Typography>
          </Grid>
          <Grid item md={6}>
            <Grid className={classes.floatRight}>
              <Typography
                className={`${paymentCostClassName.inputGroupText} ${classes.floatLeft}`}
              >
                $
              </Typography>
              <CurrencyInput
                id="input-example"
                name=""
                style={{ zIndex: 0, textAlign: 'right' }}
                // className={
                //   OtherDisable
                //     ? `${paymentCostClassName.formControl} ${paymentCostClassName.currencyInput} ${paymentCostClassName.disabledColour}`
                //     : `${paymentCostClassName.formControl} ${paymentCostClassName.currencyInput}`
                // }
                className={`${paymentCostClassName.formControl} ${paymentCostClassName.currencyInput}`}
                decimalsLimit={2}
                data-testid="ProcessingFeeTxtBoxTest"
                value={OtherAmt}
                onBlur={(e) => ProcessingFeeOnBlurClick(e)}
                onClick={(e) => ProcessingFeeOnClick(e)}
                onValueChange={(value) => ProcessingFeeOnchange(value)}
              />
            </Grid>
          </Grid>
        </Grid>
        <label
          style={{
            color: 'red',
            fontSize: 'small',
            marginLeft: '15%',

            visibility: ProcessingFeeErrorLbl === false ? 'hidden' : 'visible',
          }}
          data-testid="OverRideErrorMsgTest"
        >
          {t("Please enter a valid processing fee amount less than $")}
          {`${processingFee}`}
        </label>
        <Grid
          item
          md={12}
          className={`${classes.mt3} ${classes.pb4} ${classes.textCenter}`}
        >
          <RACButton
            className={classes.mx1}
            variant="contained"
            color="primary"
            onClick={() => OverRideAmoutClick()}
          >
            {t("Override Amount")}
          </RACButton>
        </Grid>
      </div>
    );
  };
  const setTwoFactorCompleted = (value: any) => {
    if (value) {
      setProcessingFeePopupOpen(true);
    }
  };
  const setTwoFactorCancelClick = () => {
    setSecondFactorOpen(false);
  };
  const DecliningLdwOkclick = () => {
    const Recalculatereqobj: any = priceQuoteReq;
    setDecliningLdwOpen(false);
    setoptServiceValue(t('NONE'));
    //setDropdownChanged({ ...DropdownChanged, Optservices: true });
    // Recalculatereqobj.optionalservice = {
    //   isLDWapplied: false,
    //   isClubApplied: false,
    // };
    Recalculatereqobj.isLDWApplied = false;
    Recalculatereqobj.isClubApplied = false;
    Recalculation(Recalculatereqobj);
  };
  const DecliningLdwNoclick = () => {
    setDecliningLdwOpen(false);
  };
  const AddingBenefitsPlusClubOkClick = () => {
    const Recalculatereqobj: any = priceQuoteReq;
    setAddingBpclubOpen(false);
    //setDropdownChanged({ ...DropdownChanged, Optservices: true });
    setoptServiceValue('LDWC');
    Recalculatereqobj.isLDWApplied = true;
    Recalculatereqobj.isClubApplied = true;
    Recalculation(Recalculatereqobj);
  };
  const AddingBenefitsPlusClubNoClick = () => {
    setAddingBpclubOpen(false);
  };
  const AddingBenefitsPlusClubPopup = () => {
    return (
      <Grid className="">
        <Grid className={classes.textCenter}>
          <Typography>
            {t("By choosing the option ‘LDW/Club’, you will be adding Benefit Plus club. LDW fee will be added on your current agreement and any existing agreements which do not have LDW.")}
            <Typography className={`${classes.mt2} ${classes.fontBold}`}>
              {t("Do you want to Continue?")}
            </Typography>
          </Typography>
        </Grid>
        <Grid className={`${classes.py4} ${classes.textCenter}`}>
          <RACButton
            className={classes.mx1}
            variant="outlined"
            color="primary"
            onClick={() => AddingBenefitsPlusClubNoClick()}
          >
            {t("No")}
          </RACButton>
          <RACButton
            className={classes.mx1}
            variant="contained"
            color="primary"
            onClick={() => AddingBenefitsPlusClubOkClick()}
          >
            {t("Yes")}
          </RACButton>
        </Grid>
      </Grid>
    );
  };
  const DecliningLdwPopup = () => {
    return (
      <Grid className="">
        <Grid className={classes.textCenter}>
          <Typography>
            {t("Declining LDW on this agreement will also terminate your Benefits Plus Coverage. You would not be able to reactivate club to cover any previous Paid In Full merchandise.")}
            <Typography className={`${classes.mt2} ${classes.fontBold}`}>
              {t("Do you still wish to terminate?")}
            </Typography>
          </Typography>
        </Grid>
        <Grid className={`${classes.py4} ${classes.textCenter}`}>
          <RACButton
            className={classes.mx1}
            variant="outlined"
            color="primary"
            onClick={() => DecliningLdwNoclick()}
          >
            {t("No")}
          </RACButton>
          <RACButton
            className={classes.mx1}
            variant="contained"
            color="primary"
            onClick={() => DecliningLdwOkclick()}
          >
            {t("Yes")}
          </RACButton>
        </Grid>
      </Grid>
    );
  };
  const DecliningLdwCloseClick = () => {
    setDecliningLdwOpen(false);
  };
  const AddingBpclubCloseClick = () => {
    setAddingBpclubOpen(false);
  };

  const tbTwoFactorCompletedFn = async (value?: any) => {
    debugger
    setpageLoader(true)
    const payloadarray: any = [];

    for (const value of addedItems) {
      const productsArray = {
        productNumber: value.modelNumber,
        fitmentId: salesleadFitemnetid ? salesleadFitemnetid : modelNumberArray[0].fitmentId,
        qty: value.quantity
      }
      payloadarray.push(productsArray)
    }
    // const payload = {
    //   supplierNumber: "361875",
    //   zipCode: "12345",
    //   successRedirectUrl: "https://www.successurl.com",
    //   cancelRedirectUrl: "https://www.cancelurl.com",
    //   products: [
    //     {
    //       productNumber: "TV153000774",
    //       fitmentId: "95628",
    //       qty: 4,
    //     }
    //   ]
    // }
    const payload = {
      supplierNumber: addedItems[0].supplierNumber,
      zipCode: customerInformation.addresses[0].postalCode.length > 5 ? customerInformation.addresses[0].postalCode.substring(0, 5) : customerInformation.addresses[0].postalCode,
      successRedirectUrl: "https://www.successurl.com",
      cancelRedirectUrl: "https://www.cancelurl.com",
      products: payloadarray
    }
    const tireCreateCartRes = await tireCreateCart(payload)
    setpageLoader(false)
    if (tireCreateCartRes.status == 200) {
      setIframeUrl(tireCreateCartRes?.data?.url)
      setTbIframePopup(true)
    }
    else if (tireCreateCartRes.status == 400) {
      setapiFailPopupOpen(true)
    }
    else {
      setsomethingWentWrongOpen(true)
    }
  }
  const tbTwoFactorCancelleddFn = async () => {
    settbSecondFactor(false)
  }

  const handleTwoFactorCompletion = (value) => {
    if (value) {
      rewardOnBlur(rewardEntered); // Call rewardOnBlur with the referral code
    }
  };


  function capitalize(str: string): string {
    return str.charAt(0).toUpperCase() + str.slice(1);
  }
  const docuSignOnload = () => {
    debugger
    window.addEventListener('message', (event) => {
      debugger
      var installerDetailsForm = document.getElementById('IframeID') as HTMLFormElement | null;
      if (event.data) {
        debugger;
        console.log("event.data", event.data)
        var selectedInstaller = JSON.parse(event.data).selectedInstaller;
        var selectedAppointment = JSON.parse(event.data).selectedAppointment;
        if (event.data) {
          console.log("hiiii12")
          const installerAddress = {
            addressLine1: selectedInstaller.address.line1,
            addressLine2: selectedInstaller.address.line2,
            city: selectedInstaller.address.city,
            state: selectedInstaller.address.state,
            postalCode: selectedInstaller.address.zipCode
          }
          setInstallerInfo({ ...installerInfo, installerName: selectedInstaller.name, emailAddress: selectedInstaller.address.email, phoneNumber: selectedInstaller.address.phone, installationDate: selectedAppointment.year + '-' + moment().month(selectedAppointment.month).format('MM') + '-' + selectedAppointment.date, installationTime: selectedAppointment.period, installerAddress: installerAddress })

        }

      }
      else {
        console.log('Installation Not scheduled');
      }
      setTbIframePopup(false)
      if (event.data) {
        setinstallationSuccessfull(true)
      }
    });

  }
  const tbIframePopupFn = () => {
    return (
      <Grid className={`${classes.w100} ${classes.floatLeft}`}>
        <Grid className={`${classes.w100} ${classes.floatLeft} ${classes.mb3}`}>
          {iframeUrl === '' ? (
            <Grid className={classes.iframeClass}>
              <CircularProgress
                style={{ marginTop: '200px', marginLeft: '575px' }}
                size={30}
              />
            </Grid>
          ) :
            <Grid>
              {salesinstallerName ? <>
                <Grid >
                  <Grid style={{ float: 'left' }}>
                    <Typography style={{ fontFamily: 'OpenSans-bold', fontSize: '20px', marginBottom: '23px', display: 'inline-block' }}>{t("Installtion Details chosen by Customer")}
                      <Infoicon

                        title={"Installer details for the lead will be shown here"}

                        onMouseOver={() => {

                          "Transfer";

                        }}
                      >
                      </Infoicon>
                      {/* 
                      <Infosus

                        title={"Transfer"}

                        onMouseOver={() => {

                          "Transfer";

                        }}

                      ></Infosus> */}
                    </Typography>
                  </Grid>
                  {/* <Infoicon>


                    <RACInfoIcon iconClassname={classes.ReturnInfoIcon}
                      placement='top-start'
                      infoTitle='Installer details for the lead will be shown here'
                    />

                  </Infoicon> */}
                  {/* <span className={classes.tooltip}><Infoicon></Infoicon></span><span className={classes.tooltiptext}></span> */}
                  <Grid container spacing={2} style={{ marginBottom: '23px', marginLeft: '0px' }}>
                    <Grid md={3}>
                      <Typography style={{ fontFamily: 'OpenSans-bold', fontSize: '14px' }}>{t("Installation Name")} :{salesinstallerName ? salesinstallerName : '-'}</Typography>
                    </Grid>
                    <Grid md={2}>
                      <Typography style={{ fontFamily: 'OpenSans-bold', fontSize: '14px' }}>{t("Date")} :{salesinstalldate ? salesinstalldate : '-'}</Typography>
                    </Grid>
                    <Grid md={2}>
                      <Typography style={{ fontFamily: 'OpenSans-bold', fontSize: '14px' }}>{t("Tiem Slot")}:{salesTimeSlot ? salesTimeSlot : '-'}</Typography>
                    </Grid>

                  </Grid>
                  <Typography style={{ fontFamily: 'OpenSans-bold', fontSize: '18px', marginBottom: '23px' }}> {t("Schedule Installation")} </Typography>
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      padding: '12px',
                      marginTop: 10,
                      marginBottom: 10,
                      backgroundColor: "#E0EAFF"
                    }}
                  >

                    <label
                      htmlFor="flexCheckDefault-6"
                      style={{
                        marginLeft: 10,
                        fontFamily: 'OpenSans-bold',
                        fontSize: 13,
                        color: '#2179FE',
                      }}
                    >
                      {t("Note : Customers have already selected the above installation details in leads. Please confirm the details with the customer and proceed with installation.")}
                    </label>
                  </div>
                </Grid>
              </> : <Typography style={{ fontFamily: 'OpenSans-bold', fontSize: '20px', marginBottom: '23px' }}>{t("Schedule Installation")}</Typography>}
              <iframe
                src={iframeUrl}
                className={classes.iframeClass}
                id="IframeID"
                title="Iframe"
                onLoad={() => docuSignOnload()}
              ></iframe>
              <div style={{ float: 'right', padding: '30px' }}>
                <RACButton
                  variant='outlined'
                  color='primary'
                  onClick={() => { setTbIframePopup(false) }}
                >
                  {t("Cancel")}
                </RACButton>
              </div>


            </Grid>
          }
        </Grid>
      </Grid>
    );
  };
  const TireCOCreateAgreement = async () => {
    setcreateAgrProcessingPopup(true)
    const createAgreementReqTemp: any = createAgreementReq;
    createAgreementReqTemp.sacTotal = sacAmount;
    createAgreementReqTemp.schedule = scheduleValue;
    createAgreementReqTemp.agreementSource = agreementSourceValue;
    createAgreementReqTemp.salesPersonId = salesPersonValue;
    createAgreementReqTemp.items = consolidateItemsByRmsNumber(searchResult.map((obj: any) => {
      return {
        rmsItemNumber: obj.rmsItemNumber,
        warehouseId: obj.wareHouseId,
        packageId: null,
        rmsItemQuantity: String(addedItems.filter((obj1) => obj1.modelNumber == obj.modelNumber)[0].quantity),
        weeklyRate: obj.weeklyRate,
        weeklyTerm: obj.weeklyTerm,
        cashPrice: obj.cashPrice,
        unitCost:
          obj.availability?.unitCost
            ? String(obj?.availability?.unitCost)
            : null,
        offerId:
          obj?.availability?.offerId == ''
            ? null
            : obj?.availability?.offerId,
      }
    }))
    // createAgreementReqTemp.items = [
    //   {
    //     rmsItemNumber: searchResult[0].rmsItemNumber,
    //     warehouseId: searchResult[0].wareHouseId,
    //     packageId: null,
    //     rmsItemQuantity: '1',
    //     weeklyRate: searchResult[0].weeklyRate,
    //     weeklyTerm: searchResult[0].weeklyTerm,
    //     cashPrice: searchResult[0].cashPrice,
    //     unitCost:
    //       searchResult[0].availability?.unitCost
    //         ? String(searchResult[0]?.availability?.unitCost)
    //         : null,
    //     offerId:
    //       searchResult[0]?.availability?.offerId == ''
    //         ? null
    //         : searchResult[0]?.availability?.offerId,
    //   },
    // ];
    if (isCOReferralEnabled && offerCodeValue == 'referral') {
      createAgreementReqTemp.promoCode =
        rewardEntered != '' ? rewardEntered : null;
      createAgreementReqTemp.referralCode = rewardEntered
    }
    else
      createAgreementReqTemp.promoCode =
        offerCodeValue != '' ? offerCodeValue : null;

    createAgreementReqTemp.isLDWApplied =
      optServiceValue == 'LDW' || optServiceValue == 'LDWC'
        ? 'true'
        : 'false';
    createAgreementReqTemp.isClubApplied =
      optServiceValue == 'LDWC' || optServiceValue == 'BPC'
        ? 'true'
        : 'false';
    createAgreementReqTemp.agreementRate =
      priceQuoteRes.paymentSchedule.weeklyRate;
    createAgreementReqTemp.agreementTerm =
      priceQuoteRes.paymentSchedule.weeklyTerm;

    // Local Sourcing: Enrich create agreement payload with LS fields
    applyLocalSourcingPayload(createAgreementReqTemp);
    debugger;

    const payload = { ...createAgreementReqTemp, installerInfo, vehicleInfo: vehicleInfo }
    const tireCOCreateAgreementRes = await tireCOCreateAgreement(payload)
    if (tireCOCreateAgreementRes.status == 200) {
      // Handle duplicate agreement response from Local Sourcing wrapper
      if (tireCOCreateAgreementRes.data?.isDuplicate) {
        setcreateAgrProcessingPopup(false);
        setapiFailFirstMessage(
          tireCOCreateAgreementRes.data.message ||
            t('Agreement already exists for this purchase order')
        );
        setapiFailSecondMessage(
          `${t('Agreement')} #${tireCOCreateAgreementRes.data.agreementNumber || ''}`
        );
        setapiFailPopupOpen(true);
        return;
      }
      const submittedTextBoxPromo = customerPromotions?.promotions?.find(
        (promotion: any) =>
          promotion.isTextBoxPromotion === 'Y' &&
          String(promotion.promotionNumber) ===
            String(createAgreementReqTemp.promoCode)
      );
      if (submittedTextBoxPromo) {
        window?.dataLayer?.push({
          event: 'Applied text box promo',
          customerId,
          storeNo: window.sessionStorage.getItem('storeNumber'),
          agreementNo: tireCOCreateAgreementRes.data?.agreementId?.toString(),
          employeeId: containerData?.GetEmployeeId?.() || '',
          role: currentRole || containerData?.GetRole?.() || '',
          currentScreen: 'Customer Order-Agreement Details',
          previousScreen: 'Customer Order-Item Search',
          promoNumber: submittedTextBoxPromo.promotionNumber,
          source: 'RACPAD'
        });
      }
      //setcustomerSignatureEnabled(true);
      setprocessFeeDisable(true);
      setPopupCompleteStatus({
        ...PopupCompleteStatus,
        CustomerSignComplete: false,
        AgreementCreated: true,
      });
      setAgreementId(tireCOCreateAgreementRes.data.agreementId.toString());
      setcreateAgrProcessingPopup(false);
      const AgreementCustomers =
        tireCOCreateAgreementRes.data.customerInformation;
      const Customerdata = AgreementCustomers.filter(
        (obj) => obj.priority == 1
      );
      const CustomerName =
        Customerdata[0].firstName + ' ' + Customerdata[0].lastName;
      if (AgreementCustomers.length === 1) {
        const AGreementDocObj: any = GenerateDocReq;
        const CustomerObj = [
          {
            customerId: Customerdata[0].customerId.toString(),
            customerName: CustomerName,
            phoneNumber: Customerdata[0].phoneNumber,
            emailId: Customerdata[0].emailAddress,
            priority: 1,
          },
        ];
        console.log('PayloadForm');
        AGreementDocObj.signers = CustomerObj;
        setGenerateDocReq(AGreementDocObj);
        setAgrCustomerObj(CustomerObj);
        setcustomerSignatureEnabled(true);
      } else {
        const AGreementDocObj: any = GenerateDocReq;
        const CoCustomer = AgreementCustomers.filter(
          (obj) => obj.priority == 2
        );
        const CoCustomerName =
          CoCustomer[0].firstName + ' ' + CoCustomer[0].lastName;
        const CustomerObj = [
          {
            customerId: Customerdata[0].customerId.toString(),
            customerName: CustomerName,
            phoneNumber: Customerdata[0].phoneNumber,
            emailId: Customerdata[0].emailAddress,
            priority: 1,
          },
          {
            customerId: CoCustomer[0].customerId.toString(),
            customerName: CoCustomerName,
            phoneNumber: CoCustomer[0].phoneNumber,
            emailId: CoCustomer[0].emailAddress,
            priority: 2,
          },
        ];
        AGreementDocObj.signers = CustomerObj;
        setGenerateDocReq(AGreementDocObj);
        setAgrCustomerObj(CustomerObj);
        setcustomerSignatureEnabled(true);
      }
      const AgreementDocReq: any = GenerateDocReq;
      AgreementDocReq.identifier = parseInt(
        tireCOCreateAgreementRes.data.agreementId
      );
      AgreementDocReq.identifierType = 'AGR';
      AgreementDocReq.signatureType = 1;
      AgreementDocReq.isRemote = false;
      AgreementDocReq.manualSignatureReasonId = null;
      if (AgreementCustomers.length === 1) {
        const CustomerObj = [
          {
            customerId: Customerdata[0].customerId.toString(),
            customerName: CustomerName,
            phoneNumber:
              Customerdata[0].phoneNumber !== null
                ? Customerdata[0].phoneNumber
                : '1111111111',
            emailId:
              Customerdata[0].emailAddress !== null
                ? Customerdata[0].emailAddress
                : 'test@example.com',
            priority: 1,
          },
        ];
        AgreementDocReq.signers = CustomerObj;
      } else {
        const CoCustomer = AgreementCustomers.filter(
          (obj) => obj.priority == 2
        );
        const CoCustomerName =
          CoCustomer[0].firstName + ' ' + CoCustomer[0].lastName;

        const CustomerObj = [
          {
            customerId: Customerdata[0].customerId.toString(),
            customerName: CustomerName,
            phoneNumber:
              Customerdata[0].phoneNumber !== null
                ? Customerdata[0].phoneNumber
                : '1111111111',
            emailId:
              Customerdata[0].emailAddress !== null
                ? Customerdata[0].emailAddress
                : 'test@example.com',
            priority: 1,
          },
          {
            customerId: CoCustomer[0].customerId.toString(),
            customerName: CoCustomerName,
            phoneNumber:
              CoCustomer[0].phoneNumber !== null
                ? CoCustomer[0].phoneNumber
                : '1111111111',
            emailId:
              CoCustomer[0].emailAddress !== null
                ? CoCustomer[0].emailAddress
                : 'test@example.com',
            priority: 2,
          },
        ];
        AgreementDocReq.signers = CustomerObj;
      }
      setpreviousBtnDisabled(true);
      const GenerateAgreementDocRes = await GenerateAgreementDoc(
        AgreementDocReq
      );
      console.log(
        'First Generate Agreement Call response',
        GenerateAgreementDocRes
      );
      setpreviousBtnDisabled(false);
      setdocumentGenerateCompleted(true);
      seteditDisableMode(true);
    } else if (tireCOCreateAgreementRes.status == 400) {
      setprocessFeeDisable(false);
      setcreateAgrProcessingPopup(false);
      const ErrorMessage = tireCOCreateAgreementRes.data.errors[0].error;
      setapiFailFirstMessage(ErrorMessage);
      setapiFailSecondMessage(t('Please try again'));
      setapiFailPopupOpen(true);
    } else {
      setprocessFeeDisable(false);
      setcreateAgrProcessingPopup(false);
      setsomethingWentWrongOpen(true);
    }
  }
  const installationSuccessfullPopup = () => {
    return (
      <>
        <div id="testimage" className={classes.agrTranferSuccessImg}>
          <Successicon></Successicon>
        </div>
        <Typography style={{ "textAlign": "center", "fontSize": "17px", fontFamily: 'OpenSans-bold' }}>{t("Installation scheduled successfully")}</Typography>
        <RACButton
          variant='contained'
          color='primary'
          style={{
            marginTop: '20px',
            marginLeft: '170px',
            padding: '12px 30px',
          }}
          onClick={() => {
            setinstallationSuccessfull(false)
            TireCOCreateAgreement()
          }}
        >{t("Ok")}</RACButton>
      </>
    )
  }

  return (
    <Grid>
      {pageLoader ?
        <Grid
          style={{
            position: 'fixed',
            background: '#f7f5f5',
            width: '100%',
            height: '100%',
            top: 0,
            left: 0,
            opacity: 0.6,
            zIndex: 2000,
            textAlign: 'center',
            margin: '0px 0px',
          }}
        >
          <Grid
            style={{
              display: 'block',
              position: 'fixed',
              zIndex: 9999999,
              top: '40%',
              right: '50%',
            }}
          >
            <CircularProgress />
          </Grid>
        </Grid> : null}
      {secondFactorEnabled === true ? (
        <SecondFactor
          setTwoFactorCancelClick={() => TwoFactorCancelFn()}
          setTwoFactorCompleted={(value) => TwoFactorCompleteFn(value)}
          moduleName={'Customer Order Agmt Creation'}
          currentRole={currentRole}
        />
      ) : null}
      <DEOverrideAuthGate
        deEnforcementPopup={deEnforcementPopup}
        deOverrideAuthOpen={deOverrideAuthOpen}
        setDeOverrideAuthOpen={setDeOverrideAuthOpen}
        closeDEEnforcementPopup={deEnforcementCloseClick}
        authorizeDEEnforcementOverride={deEnforcementAuthorizeClick}
        onOverrideAuthenticated={() => TwoFactorCompleteFn(true)}
        setApproverDetails={(details: any) => {
          deOverrideApproverDetailsRef.current = details;
          setDeOverrideApproverDetails(details);
        }}
        currentRole={currentRole}
        classes={classes}
      />
      {SecondFactorOpen === true ? (
        <SecondFactor
          setTwoFactorCancelClick={setTwoFactorCancelClick}
          setTwoFactorCompleted={setTwoFactorCompleted}
          moduleName={'Edit SAC Fee'}
          currentRole={currentRole}
        />
      ) : null}

      {tbSecondFactor === true ? (
        <SecondFactor
          setTwoFactorCancelClick={() => tbTwoFactorCancelleddFn()}
          setTwoFactorCompleted={(value) => tbTwoFactorCompletedFn(value)}
          moduleName={'Customer Order Agmt Creation'}
          currentRole={currentRole}
        />) : null}
      {customerSignatureEnabled ? (
        <CustomerSignature
          customerSignUsingField="agreementDetails"
          customerSignUsingModule="customerOrder"
          identifier={parseInt(AgreementId)}
          customersArr={AgrCustomerObj}
          manualSignOptions={ManualSignOptions}
          documentTypeArr={[]}
          customerSignatureCompletedFn={() => customerSignatureCompletedFn()}
          customerSignatureCanceledFn={() => customerSignatureCanceledFn()}
          emailcompletedFn={() => emailcompletedFn()}
          documentGenerateCompleted={documentGenerateCompleted}
        />
      ) : null}
      {rewardTwoFactorAuth ? (
        <SecondFactor
          setTwoFactorCancelClick={(res) => {
            setRewardTwoFactorAuth(false);
            if (res)
              setRewardEntered("");
          }}
          setTwoFactorCompleted={(success) => handleTwoFactorCompletion(success)} // Pass completion handler
          moduleName={'LinkaReferral'}
          currentRole={currentRole}
        // setApprover={true}
        />
      ) : null}
      {somethingWentWrong ? (
        <div
          className="Norecords"
          style={{ marginTop: '20%', marginLeft: '40%' }}
        >
          <Alerticon></Alerticon>
          {t("Something went wrong!")}
        </div>
      ) : (
        <Grid>
          <RACModalCard
            isOpen={tbIframePopup}
            closeIcon={true}
            // title='Schedule Installation'
            onClose={() => setTbIframePopup(false)}
            maxWidth='lg'
            children={tbIframePopupFn()}
            className={`${classes.customModal}`}
            borderRadius={'20px !important'}
          />
          <RACModalCard
            isOpen={installationSuccessfull}
            closeIcon={true}
            onClose={() => {
              setinstallationSuccessfull(false);
              TireCOCreateAgreement()

            }}
            maxWidth="xs"
            borderRadius={'20px !important'}
          >
            {installationSuccessfullPopup()}
          </RACModalCard>
          <RACModalCard
            isOpen={apiFailPopupOpen}
            closeIcon={false}
            maxWidth="xs"
            borderRadius={'20px !important'}
          >
            {ApiFailPopup()}
          </RACModalCard>
          <RACModalCard
            isOpen={AddingBpclubOpen}
            closeIcon={true}
            onClose={() => AddingBpclubCloseClick()}
            maxWidth="xs"
            borderRadius={'25px !important'}
          >
            {AddingBenefitsPlusClubPopup()}
          </RACModalCard>
          <RACModalCard
            isOpen={DecliningLdwOpen}
            onClose={() => DecliningLdwCloseClick()}
            closeIcon={true}
            maxWidth="xs"
            borderRadius={'25px !important'}
          >
            {DecliningLdwPopup()}
          </RACModalCard>
          <RACModalCard
            isOpen={ProcessingFeePopupOpen}
            closeIcon={false}
            maxWidth="sm"
            borderRadius={'25px !important'}
          >
            {ProcessingFeePopup()}
          </RACModalCard>
          <RACModalCard
            isOpen={somethingWentWrongOpen}
            closeIcon={false}
            maxWidth="xs"
            borderRadius={'20px !important'}
          >
            {SomethingWentWrongPopup()}
          </RACModalCard>
          <RACModalCard
            isOpen={createAgrProcessingPopup}
            closeIcon={false}
            maxWidth="xs"
            borderRadius={'20px !important'}
          >
            {' '}
            {CreateAgreementProcessingPopup()}
          </RACModalCard>

          <RACModalCard
            isOpen={paymentPopupOpen}
            closeIcon={true}
            onClose={() => PreliminaryPaymentCloseClick()}
            maxWidth="xs"
            borderRadius={'20px !important'}
          >
            {PreliminaryPaymentPopup()}
          </RACModalCard>
          <Grid className={classes.px2}>
            <Grid container className={classes.mt2}>
              <Typography
                variant="h6"
                className={`${classes.title} ${classes.mb1}`}
              >
                {t("Payment Schedule")}
              </Typography>
            </Grid>
            <Grid container spacing={2}>
              <PaymentScheduleCard
                Scheduloading={scheduleLoading}
                ScheduleValue={paymentScheduleValues.weeklyRate}
                ScheduleName="Weekly"
                TermValue={paymentScheduleValues.weeklyTerm}
                ScheduleSelected={selectedSchedule.WeeklySchedule}
                ScheduleClickFn={(ScheduleName) =>
                  WeeklyScheduleOnClick(ScheduleName)
                }
                EditDisableMode={editDisableMode}
              />
              <PaymentScheduleCard
                Scheduloading={scheduleLoading}
                ScheduleValue={paymentScheduleValues.biweeklyRate}
                ScheduleName="Bi-Weekly"
                TermValue={paymentScheduleValues.biweeklyTerm}
                ScheduleSelected={selectedSchedule.BiWeeklySchedule}
                ScheduleClickFn={(ScheduleName) =>
                  BiWeeklyScheduleOnClick(ScheduleName)
                }
                EditDisableMode={editDisableMode}
              />
              <PaymentScheduleCard
                Scheduloading={scheduleLoading}
                ScheduleValue={paymentScheduleValues.semimonthlyRate}
                ScheduleName="Semi-Monthly"
                TermValue={paymentScheduleValues.semimonthlyTerm}
                ScheduleSelected={selectedSchedule.SemiMonthlySchedule}
                ScheduleClickFn={(ScheduleName) =>
                  SemiMonthlyOnClick(ScheduleName)
                }
                EditDisableMode={editDisableMode}
              />
              <PaymentScheduleCard
                Scheduloading={scheduleLoading}
                ScheduleValue={paymentScheduleValues.monthlyRate}
                ScheduleName="Monthly"
                TermValue={paymentScheduleValues.monthlyTerm}
                ScheduleSelected={selectedSchedule.MonthlySchedule}
                ScheduleClickFn={(ScheduleName) =>
                  MonthlyScheduleOnClick(ScheduleName)
                }
                EditDisableMode={editDisableMode}
              />
            </Grid>
            <Grid>
              <Grid container className={classes.mt1}>
                <Typography
                  variant="h6"
                  className={`${classes.title} ${classes.mb1}`}
                >
                  {t("General Information")}
                </Typography>
              </Grid>

              <Grid container>
                <Grid item md={12} className={classes.mb4}>
                  <Card className={classes.card}>
                    <CardContent>
                      <Grid container className={classes.mb2}>
                        <Grid
                          item
                          className={agrGeneralInfoClassName.listitemstyles}
                        >
                          <Grid
                            item
                            xs="auto"
                            className={`${agrGeneralInfoClassName.paymentGeneralInfo} ${agrGeneralInfoClassName.borderRightRadius0} ${classes.pt1}`}
                          >
                            <Typography
                              variant="caption"
                              className={
                                agrGeneralInfoClassName.paymentGeneralInfoColor
                              }
                            >
                              {t("Agreement Type")} :{' '}
                            </Typography>
                            <Typography
                              variant="caption"
                              className={
                                agrGeneralInfoClassName.paymentGeneralInfoColorlabel
                              }
                            >
                              {t('Rental')}
                            </Typography>
                          </Grid>

                          <Grid
                            item
                            xs="auto"
                            className={`${agrGeneralInfoClassName.paymentGeneralInfo} ${agrGeneralInfoClassName.borderRightRadius0} ${classes.pt1}`}
                          >
                            <Typography
                              variant="caption"
                              className={
                                agrGeneralInfoClassName.paymentGeneralInfoColor
                              }
                            >
                              {'  '}{t("Pay Schedule")} :{' '}
                            </Typography>
                            {paymentScheduleEnabled === true ? (
                              <Typography
                                variant="caption"
                                className={
                                  agrGeneralInfoClassName.paymentGeneralInfoColorlabel
                                }
                              >
                                {'  '}
                                {payschedule.PayschedulePeriod !== 'Daily' &&
                                  payschedule.PayschedulePeriod !== 'daily'
                                  ? t(payschedule.PayschedulePeriod) +
                                  t(' on ') +
                                  t(payschedule.PayscheduleDay)
                                  : t(payschedule.PayschedulePeriod)}
                              </Typography>
                            ) : (
                              <Typography
                                variant="caption"
                                className={
                                  agrGeneralInfoClassName.paymentGeneralInfoColor
                                }
                              >
                                {'  '}-
                              </Typography>
                            )}
                          </Grid>
                        </Grid>
                      </Grid>

                      <Grid container spacing={2}>
                        <Grid item sm={4} md={2} style={{ maxWidth: '13.666667%' }}>
                          <RACSelect
                            inputLabelClassName={
                              agrGeneralInfoClassName.dropDownLabel
                            }
                            inputLabel={t("Agreement Source")}
                            options={agreementSourceOptions}
                            defaultValue={agreementSourceValue}
                            // isDisabled={editDisableMode}
                            isDisabled={AgrSourceDisable}
                            onChange={(e: any) =>
                              AgreementSourceOnchange(e.target.value)
                            }
                            loading={dropdownLoading}
                            {...(agreementSourceOptions.length == 1 &&
                              dropdownLoaded && {
                              errorMessage: API_ERROR_MESSAGE,
                            })}
                          />

                        </Grid>

                        <Grid item sm={4} md={2} style={{ maxWidth: '13.666667%' }}>
                          <RACSelect
                            inputLabelClassName={
                              agrGeneralInfoClassName.dropDownLabel
                            }
                            name="Schedule"
                            inputLabel={t("Schedule")}
                            options={scheduleOptions}
                            defaultValue={scheduleValue}
                            isDisabled={editDisableMode}
                            onChange={(e: any) =>
                              ScheduleOnchange(e.target.value)
                            }
                            loading={dropdownLoading}
                            {...(scheduleOptions.length == 1 &&
                              dropdownLoaded && {
                              errorMessage: API_ERROR_MESSAGE,
                            })}
                          />
                          <Typography
                            variant="body1"
                            className={classes.font14}
                          >
                            {t("Term")}
                            <Typography
                              variant="caption"
                              className={`${classes.bold} ${classes.racTextGreen} ${classes.ms1}`}
                            >
                              {termValue}
                            </Typography>
                          </Typography>
                        </Grid>

                        {rangeactive === true ? (
                          <Grid item sm={4} md={2} style={{ maxWidth: '13.666667%' }}>
                            <RACSelect
                              inputLabelClassName={
                                agrGeneralInfoClassName.dropDownLabel
                              }
                              name="Range"
                              inputLabel={t("Range")}
                              options={rangeOptions}
                              defaultValue={rangeValue}
                              isDisabled={editDisableMode}
                              onChange={(e: any) =>
                                RangeOnchange(e.target.value)
                              }
                              loading={dropdownLoading}
                              {...(rangeOptions.length == 1 &&
                                dropdownLoaded && {
                                errorMessage: API_ERROR_MESSAGE,
                              })}
                            />
                          </Grid>
                        ) : null}
                        <Grid item sm={4} md={2} style={{ maxWidth: '13.666667%' }}>
                          <RACSelect
                            inputLabelClassName={
                              agrGeneralInfoClassName.dropDownLabel
                            }
                            name="Opt Services"
                            inputLabel={t("Opt Services")}
                            options={optServiceOptions}
                            defaultValue={optServiceValue}
                            isDisabled={editDisableMode}
                            onChange={(e: any) =>
                              OptServiceOnchange(e.target.value)
                            }
                            loading={dropdownLoading}
                            {...(optServiceOptions.length == 1 &&
                              dropdownLoaded && {
                              errorMessage: API_ERROR_MESSAGE,
                            })}
                          />
                        </Grid>
                        <Grid item sm={4} md={2} style={{ maxWidth: '13.666667%' }}>
                          <RACSelect
                            inputLabelClassName={
                              agrGeneralInfoClassName.dropDownLabel
                            }
                            name=" Sales Person"
                            inputLabel={t("SalesPerson")}
                            required={true}
                            options={salesPersonOptions}
                            defaultValue={salesPersonValue}
                            isDisabled={editDisableMode}
                            onChange={(e: any) =>
                              SalesPersonOnchange(e.target.value)
                            }
                            loading={dropdownLoading}
                            {...(optServiceOptions.length == 1 &&
                              dropdownLoaded && {
                              errorMessage: API_ERROR_MESSAGE,
                            })}
                          />
                        </Grid>
                        { getCustomerResponse?.GetCustomer?.value?.coworker != 'Y' && 
                        <Grid item sm={featureFlagDetails?.EnableCOTextBoxPromo == '1' ? 8 : 4} md={featureFlagDetails?.EnableCOTextBoxPromo == '1' ? 4 : 2} style={{ maxWidth: featureFlagDetails?.EnableCOTextBoxPromo == '1' ? '28%' : '13.666667%' }}>
                          <Typography
                            variant="caption"
                            className={agrGeneralInfoClassName.dropDownLabel}
                            style={{ fontFamily: 'OpenSans-semibold', fontSize: '14px' }}
                          >
                            {t("Promo Code")}
                          </Typography>
                          <Grid container alignItems="center" spacing={1}>
                            <Grid item style={{ flex: 1 }}>
                              <RACSelect
                                inputLabelClassName={
                                  agrGeneralInfoClassName.dropDownLabel
                                }
                                name=" PromoCode"
                                options={offerCodeOptions || promoCodeOptions}
                                defaultValue={promoTextInput !== '' ? '' : (offerCodeValue || promoCode)}
                                isDisabled={editDisableMode || promoTextInput !== ''}
                                onChange={(e: any) =>
                                  OfferCodeOnchange(e.target.value)
                                }
                                loading={dropdownLoading}
                                {...(offerCodeOptions.length == 1 &&
                                  dropdownLoaded && {
                                  errorMessage: API_ERROR_MESSAGE,
                                })}
                              />
                            </Grid>
                            {featureFlagDetails?.EnableCOTextBoxPromo == '1' && (<>
                            <Grid item>
                              <Typography variant="body2" style={{ fontWeight: 600, padding: '0 4px' }}>
                                {t("(Or)")}
                              </Typography>
                            </Grid>
                            <Grid item style={{ flex: 1 }}>
                              <RACTextbox
                                value={promoTextInput}
                                OnChange={(e) => {
                                  const value = e.target.value.replace(/[ ,]/g, "");
                                  setPromoTextInput(value);
                                  setPromoTextError('');
                                  if (value === '') {
                                    OfferCodeOnchange('');
                                  }
                                }}
                                Onblur={(e) => {
                                  const value = e.target.value.trim();
                                  if (value === '') {
                                    setPromoTextError('');
                                    setPromoTextInput('');
                                    OfferCodeOnchange('');
                                    return;
                                  }
                                  // Validate against stored textbox promotions (isTextBoxPromotion === 'Y')
                                  const matchedPromo = textBoxPromotions.find(
                                    (p: any) => p.promotionCode?.toLowerCase() === value.toLowerCase()
                                  );
                                  if (!matchedPromo) {
                                    trackInvalidTextBoxPromo(value);
                                    setPromoTextError(t('Promo code is not valid'));
                                    return;
                                  }
                                  setPromoTextError('');
                                  const promoNumber = matchedPromo.promotionNumber;
                                  OfferCodeOnchange(promoNumber);
                                }}
                                disabled={editDisableMode || (offerCodeValue !== '' && offerCodeValue !== undefined && promoTextInput === '')}
                                placeHolder={t("Enter Promo")}
                              />
                              {promoTextError !== '' && (
                                <span style={{ color: 'red', fontSize: '11px', fontFamily: 'OpenSans-semibold' }}>
                                  {promoTextError}
                                </span>
                              )}
                            </Grid>
                            </>)}
                          </Grid>
                        </Grid>}
                        {offerCodeValue == 'referral' &&
                          (<Grid item sm={4} md={2} style={{ maxWidth: '14%' }}>
                            <RACTextbox
                              value={rewardEntered}
                              OnChange={(e) => {
                                let value = e.target.value.replace(/[ ,]/g, "")
                                setRewardEntered(value);
                                setRewardErrorMessage({ ...rewardErrorMessage, isInvalidMsg: '', isSuccessMsg: '' })
                              }}
                              Onblur={(e) => {
                                if (e.target.value?.length > 0) {
                                  setRewardTwoFactorAuth(true);
                                }
                              }}
                              disabled={customerReferralCode ? true : false}
                              inputLabelClassname={agrGeneralInfoClassName.dropDownLabel}
                              inputlabel="Referral Code"
                            />
                            {rewardErrorMessage?.isSuccessMsg != '' ? <span style={{ color: 'green', fontSize: '11px', fontFamily: 'OpenSans-semibold' }}>{rewardErrorMessage?.isSuccessMsg}</span> : rewardErrorMessage?.isInvalidMsg != '' ? <span style={{ color: 'red', fontSize: '11px', fontFamily: 'OpenSans-semibold' }}>{rewardErrorMessage?.isInvalidMsg}</span> : ''}
                            {console.log('rewardErrorMessage', rewardErrorMessage)}
                          </Grid>)}
                      </Grid>
                    </CardContent>
                  </Card>
                </Grid>
              </Grid>
            </Grid>
            <Grid container className={classes.mb6}>
              <Grid item className={paymentCostClassName.paymentWidget}>
                <Grid container spacing={3}>
                  <Grid item md={6}>
                    <Typography className={classes.title}>
                      {t("Initial Payment")}
                    </Typography>

                    <Card className={classes.card}>
                      <CardContent className={classes.p32}>
                        <Grid
                          container
                          className={`${classes.mb2} ${classes.mt2}`}
                        >
                          <Grid item md={6} className={classes.floatLeft}>
                            <Typography
                              variant="subtitle1"
                              className={paymentCostClassName.cardLabel}
                            >
                              {t("Processing Fee")}
                            </Typography>
                          </Grid>
                          <Grid item md={6}>
                            <Grid className={classes.floatRight}>
                              <Typography
                                className={`${paymentCostClassName.inputGroupText} ${classes.floatLeft}`}
                              >
                                $
                              </Typography>
                              <CurrencyInput
                                id="input-example"
                                name=""
                                style={{ zIndex: 0, textAlign: 'right' }}
                                className={
                                  processFeeDisable
                                    ? `${paymentCostClassName.formControl} ${paymentCostClassName.currencyInput} ${paymentCostClassName.disabledColour}`
                                    : `${paymentCostClassName.formControl} ${paymentCostClassName.currencyInput} `
                                }
                                //disabled={OtherAmt == '0.00' ? true : false}
                                disabled={processFeeDisable}
                                decimalsLimit={2}
                                data-testid="ProcessingFeeTxtBoxTest"
                                // value={processingFee}
                                value={OtherAmt}
                                onBlur={(e) => OtherAmtOnblurClick(e)}
                                onClick={() => OtherAmountOnclick()}
                              />
                            </Grid>
                          </Grid>
                        </Grid>

                        <Grid
                          container
                          className={`${classes.mb2} ${classes.mt2}`}
                        >
                          <Grid item md={6} className={classes.floatLeft}>
                            <Typography
                              variant="subtitle1"
                              className={paymentCostClassName.cardLabel}
                            >
                              {t("WL Deposit")}
                            </Typography>
                          </Grid>
                          <Grid item md={6}>
                            <Grid className={classes.floatRight}>
                              <Typography
                                className={`${paymentCostClassName.inputGroupText} ${classes.floatLeft}`}
                              >
                                $
                              </Typography>
                              <CurrencyInput
                                id="input-example"
                                name=""
                                style={{ zIndex: 0, textAlign: 'right' }}
                                className={`${paymentCostClassName.formControl} ${paymentCostClassName.currencyInput} ${paymentCostClassName.disabledColour}`}
                                decimalsLimit={2}
                                data-testid="ProcessingFeeTxtBoxTest"
                                value={wlDeposit}
                              />
                            </Grid>
                          </Grid>
                        </Grid>
                        <Grid
                          container
                          className={`${classes.mb2} ${classes.mt4}`}
                        >
                          <Grid item md={7}>
                            <Typography
                              variant="subtitle1"
                              className={paymentCostClassName.cardLabel}
                            >
                              {t("Rate")}
                            </Typography>
                          </Grid>
                          <Grid item md={5}>
                            {!pageLoading ? (
                              <Typography
                                variant="subtitle1"
                                className={paymentCostClassName.widgetAlign}
                              >
                                $ {formatMoney(initialPaymentAmount.Rate)}
                              </Typography>
                            ) : (
                              <Typography
                                variant="subtitle1"
                                className={paymentCostClassName.widgetAlign}
                              >
                                <Skeleton
                                  count={1}
                                  baseColor="#FFFFFF"
                                  highlightColor="#e7e7e7"
                                />
                              </Typography>
                            )}
                          </Grid>
                        </Grid>
                        {featureFlagDetails?.EnableRewardPromotion == '1' && Number(rewardAppliedPriceQuoteAmount ?? 0) > 0 && rewardErrorMessage?.isSuccessMsg != '' && <Grid
                          container
                          className={`${classes.mb2} ${classes.mt4}`}
                        >
                          <Grid item md={7}>
                            <Typography
                              variant="subtitle1"
                              className={paymentCostClassName.cardLabel}
                            >
                              RAC Rewards
                            </Typography>
                          </Grid>
                          <Grid item md={5}>
                            {!pageLoading ? (
                              <Typography
                                variant="subtitle1"
                                className={paymentCostClassName.widgetAlign}
                              >
                                -$ {formatMoney(rewardAppliedPriceQuoteAmount)}
                              </Typography>
                            ) : (
                              <Typography
                                variant="subtitle1"
                                className={paymentCostClassName.widgetAlign}
                              >
                                <Skeleton
                                  count={1}
                                  baseColor="#FFFFFF"
                                  highlightColor="#e7e7e7"
                                />
                              </Typography>
                            )}
                          </Grid>
                        </Grid>}
                        <Grid
                          container
                          className={`${classes.mb2} ${classes.mt4}`}
                        >
                          <Grid item md={7}>
                            <Typography
                              variant="subtitle1"
                              className={paymentCostClassName.cardLabel}
                            >
                              {t("LDW")}
                            </Typography>
                          </Grid>
                          <Grid item md={5}>
                            {!pageLoading ? (
                              <Typography>
                                <Typography
                                  variant="subtitle1"
                                  className={paymentCostClassName.widgetAlign}
                                >
                                  $ {formatMoney(initialPaymentAmount.LDW)}
                                </Typography>
                              </Typography>
                            ) : (
                              <Typography
                                variant="subtitle1"
                                className={paymentCostClassName.widgetAlign}
                              >
                                <Skeleton
                                  count={1}
                                  baseColor="#FFFFFF"
                                  highlightColor="#e7e7e7"
                                />
                              </Typography>
                            )}
                          </Grid>
                        </Grid>
                        <Grid
                          container
                          className={`${classes.mb2} ${classes.mt4}`}
                        >
                          <Grid item md={7}>
                            <Typography
                              variant="subtitle1"
                              className={paymentCostClassName.cardLabel}
                            >
                              {t("Club")}
                            </Typography>
                          </Grid>
                          <Grid item md={5}>
                            {!pageLoading ? (
                              <Typography
                                variant="subtitle1"
                                className={paymentCostClassName.widgetAlign}
                              >
                                $ {formatMoney(initialPaymentAmount.Club)}
                              </Typography>
                            ) : (
                              <Typography
                                variant="subtitle1"
                                className={paymentCostClassName.widgetAlign}
                              >
                                <Skeleton
                                  count={1}
                                  baseColor="#FFFFFF"
                                  highlightColor="#e7e7e7"
                                />
                              </Typography>
                            )}
                          </Grid>
                        </Grid>
                        <Grid
                          container
                          className={`${classes.mb2} ${classes.mt4}`}
                        >
                          <Grid item md={7}>
                            <Typography
                              variant="subtitle1"
                              className={paymentCostClassName.cardLabel}
                            >
                              {t("Tax")}
                            </Typography>
                          </Grid>
                          <Grid item md={5}>
                            {!pageLoading ? (
                              <Typography
                                variant="subtitle1"
                                className={paymentCostClassName.widgetAlign}
                              >
                                $ {formatMoney(initialPaymentAmount.Tax)}
                              </Typography>
                            ) : (
                              <Typography
                                variant="subtitle1"
                                className={paymentCostClassName.widgetAlign}
                              >
                                <Skeleton
                                  count={1}
                                  baseColor="#FFFFFF"
                                  highlightColor="#e7e7e7"
                                />
                              </Typography>
                            )}
                          </Grid>
                        </Grid>

                        <Grid
                          container
                          className={`${classes.mb2} ${classes.pt2} ${paymentCostClassName.payscheduleBorder} ${paymentCostClassName.alignCenter} ${classes.mt4}`}
                        >
                          <Grid item md={7}>
                            <Typography
                              variant="subtitle1"
                              className={`${classes.font18} ${classes.semiBold}`}
                            >
                              {t("Initial Payment")}{' '}
                            </Typography>
                          </Grid>
                          <Grid item md={5}>
                            {!pageLoading ? (
                              <Typography
                                variant="subtitle1"
                                className={`${classes.font24} ${classes.bold} ${classes.textRight}`}
                              >
                                ${' '}
                                {formatMoney(
                                  initialPaymentAmount.InitialPayment
                                )}
                              </Typography>
                            ) : (
                              <Typography
                                variant="subtitle1"
                                className={`${classes.font24} ${classes.bold} ${classes.textRight}`}
                              >
                                <Skeleton
                                  count={1}
                                  baseColor="#FFFFFF"
                                  highlightColor="#e7e7e7"
                                />
                              </Typography>
                            )}
                          </Grid>
                        </Grid>
                      </CardContent>
                    </Card>
                  </Grid>

                  <Grid item md={6}>
                    <Typography className={classes.title}>
                      {t("Total Payment/Total Cost")}
                    </Typography>

                    <Card className={paymentCostClassName.bluecard}>
                      <CardContent className={classes.p4}>
                        <Grid
                          container
                          className={`${classes.mb2} ${classes.mt4}`}
                        >
                          <Grid item md={7}>
                            <Typography
                              variant="subtitle1"
                              className={paymentCostClassName.blueCardLabel}
                            >
                              {/* Initial Payment (
                              {totalPaymentAmount.InitialPaymentTerm}) */}
                              {t("Intial Payment")}
                            </Typography>
                          </Grid>
                          <Grid item md={5}>
                            {!pageLoading ? (
                              <Typography
                                variant="subtitle1"
                                className={paymentCostClassName.blueWidgetAlign}
                              >
                                ${' '}
                                {formatMoney(totalPaymentAmount.InitialPayment)}
                              </Typography>
                            ) : (
                              <Typography
                                variant="subtitle1"
                                className={paymentCostClassName.blueWidgetAlign}
                              >
                                <Skeleton
                                  count={1}
                                  baseColor={RACCOLOR.NORMAL_BLUE}
                                  highlightColor="#FFFFFF"
                                />
                              </Typography>
                            )}
                          </Grid>
                        </Grid>

                        <Grid
                          container
                          className={`${classes.mb2} ${classes.mt4}`}
                        >
                          <Grid item md={7}>
                            {!pageLoading ? (
                              <Typography
                                variant="subtitle1"
                                className={paymentCostClassName.blueCardLabel}
                              >
                                {t("Regular Payments")} (
                                {totalPaymentAmount.RegularPaymentsTerm})
                              </Typography>
                            ) : (
                              <Typography
                                variant="subtitle1"
                                className={paymentCostClassName.blueCardLabel}
                              >
                                {t("Regular Payments")}
                              </Typography>
                            )}
                          </Grid>
                          <Grid item md={5}>
                            {!pageLoading ? (
                              <Typography
                                variant="subtitle1"
                                className={paymentCostClassName.blueWidgetAlign}
                              >
                                ${' '}
                                {formatMoney(
                                  totalPaymentAmount.RegularPayments
                                )}
                              </Typography>
                            ) : (
                              <Typography
                                variant="subtitle1"
                                className={paymentCostClassName.blueWidgetAlign}
                              >
                                <Skeleton
                                  count={1}
                                  baseColor={RACCOLOR.NORMAL_BLUE}
                                  highlightColor="#FFFFFF"
                                />
                              </Typography>
                            )}
                          </Grid>
                        </Grid>

                          {featureFlagDetails?.EnableCustomerTierReward == '1' && (tierPromotionsValue?.promotionCode || tierPromotionsValue?.promotionNumber) &&
                            <Grid container className={`${classes.mb2} ${classes.mt4}`}>
                              <Grid item md={7}>
                                <Typography
                                  variant="subtitle1"
                                  className={paymentCostClassName.blueCardLabel}
                                >
                                  {matchingPromotions[0]?.promotionCode}
                                </Typography>
                              </Grid>
                              <Grid item md={5}>
                                {!pageLoading ? (
                                  <Typography
                                    variant="subtitle1"
                                    className={paymentCostClassName.blueWidgetAlign}
                                  >
                                    - $ {formatMoney(totalPaymentAmount.Discount)}
                                  </Typography>
                                ) : (
                                  <Typography
                                    variant="subtitle1"
                                    className={paymentCostClassName.blueWidgetAlign}
                                  >
                                    <Skeleton
                                      count={1}
                                      baseColor={RACCOLOR.NORMAL_BLUE}
                                      highlightColor="#FFFFFF"
                                    />
                                  </Typography>
                                )}
                              </Grid>
                            </Grid>
                          }

                        <Grid
                          container
                          className={`${classes.mb2} ${classes.mt4}`}
                        >
                          <Grid item md={7}>
                            <Typography
                              variant="subtitle1"
                              className={paymentCostClassName.blueCardLabel}
                            >
                              {/* Final Payment (
                              {totalPaymentAmount.FinalPaymentTerm}) */}
                              {t("Final Payment")}
                            </Typography>
                          </Grid>
                          <Grid item md={5}>
                            {!pageLoading ? (
                              <Typography
                                variant="subtitle1"
                                className={paymentCostClassName.blueWidgetAlign}
                              >
                                $ {formatMoney(totalPaymentAmount.FinalPayment)}
                              </Typography>
                            ) : (
                              <Typography
                                variant="subtitle1"
                                className={paymentCostClassName.blueWidgetAlign}
                              >
                                <Skeleton
                                  count={1}
                                  baseColor={RACCOLOR.NORMAL_BLUE}
                                  highlightColor="#FFFFFF"
                                />
                              </Typography>
                            )}
                          </Grid>
                        </Grid>

                        <Grid
                          container
                          className={`${classes.mb2} ${classes.mt4}`}
                        >
                          <Grid item md={12}>
                            {!pageLoading ? (
                              <Typography
                                variant="subtitle1"
                                className={paymentCostClassName.blueCardLabel}
                              >
                                {' '}
                                {t("Total Payments")} (
                                {totalPaymentAmount.TotalPaymentTerm})
                              </Typography>
                            ) : (
                              <Typography
                                variant="subtitle1"
                                className={paymentCostClassName.blueCardLabel}
                              >
                                {' '}
                                {t("Total Payments")}
                              </Typography>
                            )}
                          </Grid>
                        </Grid>

                        <Card
                          className={`${classes.card} ${classes.p3} ${paymentCostClassName.mtcustom} ${paymentCostClassName.totalPaymentShade}`}
                        >
                          <Grid container className={classes.mb2}>
                            <Grid item md={7} className={classes.floatLeft}>
                              <Typography
                                variant="subtitle1"
                                className={paymentCostClassName.totalValue}
                              >
                                {t("Same As Cash Total")}
                              </Typography>
                            </Grid>

                            <Grid item md={5}>
                              <Grid className={classes.floatRight}>
                                <Typography
                                  className={`${paymentCostClassName.inputGroupText} ${classes.floatLeft}`}
                                >
                                  $
                                </Typography>
                                <CurrencyInput
                                  id="input-example"
                                  name=""
                                  style={{ zIndex: 0, textAlign: 'right' }}
                                  className={`${paymentCostClassName.formControl} ${paymentCostClassName.currencyInput} ${paymentCostClassName.disabledColour}`}
                                  decimalsLimit={2}
                                  disabled={true}
                                  data-testid="ProcessingFeeTxtBoxTest"
                                  value={sacAmount}
                                />
                              </Grid>
                            </Grid>
                          </Grid>

                          <Grid
                            container
                            className={paymentCostClassName.alignCenter}
                          >
                            <Grid item md={7}>
                              <Typography
                                variant="subtitle1"
                                className={paymentCostClassName.totalValue}
                              >
                                {t("Agreement Total")}
                              </Typography>
                            </Grid>
                            <Grid item md={5}>
                              {!pageLoading ? (
                                <Typography
                                  variant="subtitle1"
                                  className={
                                    paymentCostClassName.agreementTotal
                                  }
                                >
                                  ${' '}
                                  {formatMoney(
                                    totalPaymentAmount.AgreementTotal
                                  )}
                                </Typography>
                              ) : (
                                <Typography
                                  variant="subtitle1"
                                  className={
                                    paymentCostClassName.agreementTotal
                                  }
                                >
                                  <Skeleton
                                    count={1}
                                    baseColor="#FFFFFF"
                                    highlightColor="#e7e7e7"
                                  />
                                </Typography>
                              )}
                            </Grid>
                          </Grid>
                        </Card>
                      </CardContent>
                    </Card>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
            <Grid item className={`${classes.fixedBottom}`}>
              <RACButton
                className={`${classes.mx1} ${classes.floatLeft}`}
                variant="outlined"
                color="primary"
                onClick={() => PreviousBtnClick()}
                disabled={previousBtnDisabled}
              >
                {t("Previous")}
              </RACButton>
              <Grid className={`${classes.floatRight} ${classes.agrVoidAgreementPopupBtn}`}>
                <Grid className={`${classes.me2}`}>
                  {VoidEnabled === true &&
                    IsAgreementVoided !== true && featureFlagDetails?.EnablePreDeliveryCancellation === '1' ? (
                    <VoidAgreement
                      AgreementId={AgreementId}
                      customerId={customerId}
                      COVoidFlow={agreementStatus}
                      func={pull_data}
                    />
                  ) : null}
                </Grid>

                <RACButton
                  className={`${classes.me2} ${classes.floatRight}`}
                  variant="contained"
                  color="primary"
                  onClick={() => NextBtnClick()}
                  disabled={nextBtnDisabled || rewardErrorMessage?.isInvalidMsg != '' || (rewardEntered == '' && offerCodeValue == 'referral') ? true : false}
                >
                  {t("Next")}
                </RACButton>

              </Grid>
            </Grid>
          </Grid>
        </Grid>
      )}
    </Grid>
  );
}
